import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { REACT_APP_BASE_URL } from "../../Constants";
import { findIndex, includes } from "lodash";
import { Link, useNavigate, useParams } from "react-router-dom";
import MInput from "../../Components/Input";
import MTable from "../../Components/MTable/MTable";
import Overlay from "../../Components/Overlay";
import MTextarea from "../../Components/TextArea";
import moment from "moment";
import {
  getCountryAll,
  getProvince,
  createCustomer,
  getCustomerAll,
  updateCustomer,
  getSeries,
  getDebitorAccount,
  getPPN,
  createAddress,
  getListProduk,
  getPromo,
  createSOHeader,
  getStok,
  applyCampaign,
  getOrderType,
  createSODetail,
  deleteSODetail,
  getSOHeader,
  getCustomer,
  updateDelivery,
  updateSODetail,
  updateAddressCustomer,
  updateSO,
  createPayment,
  deletePayment,
  createTax,
  getSeriesCustomer,
  cekDraft,
  cekPOExist,
  submitPO,
  getBank,
  getCustomerPph,
  verifyPayment,
  sendMail,
  cancelpromokodeSvc,
  createPaymentGateway,
  cancelPaymentLink,
  getPromoDetail,
  sendEmailNonIpg,
  getExcludeGudang,
  getAddDocsStatus,
  rehitInvoice,
  rehitDP,
  syncCustomer,
  deleteCustomer,
  getTransitWhsCabang,
  hitIncomingPayment,
  getDealerNonPKP
} from "../../Service/SalesService";
import { getStok as getStockTransit } from "../../Service/PurchaseOrderService";
import MSelect from "../../Components/MSelect";
import { handlerFormError, isObjectEmpty, uuid } from "../../Utils/Utils";
import Swal from "sweetalert2";
import Modal from "../../Components/Layout/Modal";
import ModalPromo from "../../Components/Sales/ModalPromo";
import { NumberFormat } from "../../Components/NumberFormat";
import { empty_data, print, trash } from "../../Images";
import PrintSO from "./PrintSO";
import { useReactToPrint } from "react-to-print";
import { ParseDecimal } from "../../Components/CurrencyInput/ParseDecimal";
import CurrencyInput from "react-currency-input-field";

import { getCustInfo } from "../../Service/PurchaseOrderService";
import { Button } from "primereact/button";

let processingId = -1;
const { $ } = window;
const SalesForm = () => {
  const modalAdditionalRef = useRef({});
  const componentRef = useRef();
  const navigate = useNavigate();
  const { pageState, id_so } = useParams();
  let { userInfo } = useSelector((state) => state.auth);
  const mTableP = useRef();
  const mTableC = useRef();
  const mTablePPH = useRef();
  const deductionType = useRef();
  const [linePayment, setLinePayment] = useState(1);
  const [totalBeforeTax, setTotalBeforeTax] = useState(0);

  const [prices, setPrices] = useState([]);
  const [net_discs, setNetDiscs] = useState([]);
  const [orderNumber, setOrderNumber] = useState("");

  const options = [{ value: "ID", label: "Indonesia" }];
  const options_payment = [
    { value: "IPG", label: "PAYMENT GATEWAY" },
    { value: "KREDIT", label: "KARTU KREDIT" },
    { value: "DEBIT", label: "KARTU DEBIT" },
  ];
  const [indent_warehouses, setIndentWarehouses] = useState([]);
  const [warehouseCount, setWarehouseCount] = useState({
    ready_count: 0,
    indent_count: 0,
  });

  useEffect(() => {
    if (orderNumber) {
      if (warehouseCount.ready_count > 0 && warehouseCount.indent_count > 0) {
        getAddDocsStatus("both", orderNumber).then((res) => {
          if (res.status == 200)
            setRehitButtonsState({
              invoice_rehit: res.data?.data?.invoiceRehit,
              dp_rehit: res.data?.data?.dpRehit,
              inv_number: res.data?.data?.inv_number,
              dp_number: res.data?.data?.dp_number,
            });
        });
      } else if (warehouseCount.ready_count > 0) {
        getAddDocsStatus("invoice", orderNumber).then((res) => {
          if (res.status == 200)
            setRehitButtonsState({
              invoice_rehit: res.data?.data?.invoiceRehit,
              dp_rehit: res.data?.data?.dpRehit,
              inv_number: res.data?.data?.inv_number,
              dp_number: res.data?.data?.dp_number,
            });
        });
      } else if (warehouseCount.indent_count > 0) {
        getAddDocsStatus("dp", orderNumber).then((res) => {
          if (res.status == 200)
            setRehitButtonsState({
              invoice_rehit: res.data?.data?.invoiceRehit,
              dp_rehit: res.data?.data?.dpRehit,
              inv_number: res.data?.data?.inv_number,
              dp_number: res.data?.data?.dp_number,
            });
        });
      }
    }
  }, [warehouseCount, orderNumber]);
  //const [product_grade, setProductGrade] = useState("A");
  const [info, setInfo] = useState({
    legal: "",
    user_information: "",
    sales_remark: "",
    payment_verification_date: "",
    payment_verified: false,
    payment_verified_by: "",
    nama_customer: "",
    kode_customer: "",
    phone: "",
    email: "",
    address: "",
    delivery_date: moment().format("YYYY-MM-DD"),
    created_date: moment().format("YYYY-MM-DD"),
    detail: [],
    listppn: [],
    country: [],
    province: [],
    province_label: "",
    city: [],
    ordertype: [],
    bank: [],
    exclude_gudang: [],
    transit_gudang: [],
    city_label: "",
    series: "",
    series_cust: "",
    total: 0,
    total_before_discount_with_free: 0,
    total_ppn: 0,
    total_pph: 0,
    total_dpp: 0,
    diskon_promo: 0,
    grand_total: 0,
    total_discount: 0,
    deduction: 0,
    pph_rate: 0,
    WTCode: "",
    WTName: "",
    status_so: "",
    kupon_kode: "",
  });
  const [rehitButtonsState, setRehitButtonsState] = useState({
    invoice_rehit: false,
    dp_rehit: false,
    inv_number: "",
    dp_number: "",
  });
  const [state, setState] = useState({
    customer_saving: false,
    enable_add_product_detail: true,
    deduction_comment: "",
    po_list: [],
    processing: false,
    processingBtn: false,
    loading: false,
    refresh: false,
    locked: false,
    payment_show: false,
    county: "ID",
    province: "",
    city: "",
    order_type: "FGS",
    ShipToCode: "",
    DefaultIndentShipToCode: "",
    DefaultIndentShipToDesc: "",
    showProduct: false,
    order_id: null,
    order_no: "",
    docnum: "",
    listPromo: [],
    listPayment: [],
    listPromoSelected: "",
    note_approval: "",
    approved_date: null,
    total_payment: 0,
    showbtnpayment: false,
    showbtnresubmitpo: false,
    deduction_type: "Amount",
    deduction_amount: 0,
    ppn_selected: 11,
    sales_name: "",
    with_ip: false,
    ip_doc_entry: null,
    opsiProduct: {
      itemname: "",
      itemno: "",
      price: 0,
      qty: 1,
      type: "D",
      paketid: "",
      gudang: "",
      grade: "A",
    },
    customer: {
      cardid: "",
      CardName: "",
      CardType: "C",
      Phone1: "",
      EmailAddress: "",
      Address: "",
      form_country: "",
      form_city: "",
      form_province: "",
      WTCode: "",
      Series: "",
      DebPayAcct: "",
      DpmClear: "",
      ECVatGroup: "",
      validFor: "Y",
      branch: userInfo.BPLId,
      GroupCode: userInfo.GroupCode,
    },
  });

  const { detail, deduction, listppn, total_discount, bank } = info;
  const {
    po_list,
    listPayment,
    locked,
    refresh,
    deduction_type,
    deduction_amount,
    showbtnresubmitpo,
    order_no,
  } = state;

  const [hide_submit_payment, setHideSubmitPayment] = useState(false);

  const [stateGrade, setStateGrade] = useState("A");
  const [stateEventType, setStateEventType] = useState("FGS");

  const [showBankCardnumber, setShowBankCardnumber] = useState(false);

  const setValueDisc = (value_disc) => {
    if (value_disc && value_disc > 0) {
      if (value_disc == 100) return 100;
      else return value_disc;
    }
    return 0;
  };

  const showPayment = (doc_num_so, so_status) => {
    if (doc_num_so.substring(0, 3) == "TMP") return false;
    else if (so_status == "Cancelled") return false;
    else if (
      so_status == "Open" ||
      so_status == "Closed" ||
      so_status == "Sync" ||
      so_status == "NotSync"
    )
      return true;
    else return false;
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    values: {
      CardName: "",
      CardType: "C",
      Phone1: "",
      Address: "",
      form_country: "ID",
      form_city: "",
      form_province: "",
      WTCode: "",
      Series: "",
      DebPayAcct: "",
      DpmClear: "",
      ECVatGroup: "",
      validFor: "Y",
      branch: userInfo.BPLId,
      GroupCode: userInfo.GroupCode,
      EmailAddress: "",
    },
  });

  const columns = [
    {
      id: 1,
      title: "Customer Code",
      field: "CardCode",
      sortable: true,
      render: (item) => {
        return (
          <a
            onClick={onSelect(item)}
            style={{
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            {item.CardCode}
          </a>
        );
      },
    },
    {
      id: 2,
      title: "Nama Customer",
      field: "CardName",
      sortable: true,
      render: (item) => {
        return (
          <a
            onClick={onSelect(item)}
            style={{
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            {item.CardName}
          </a>
        );
      },
    },
    {
      id: 3,
      title: "Phone Number",
      field: "Phone1",
      sortable: true,
      render: (item) => {
        return <span>+62{item.Phone1}</span>;
      },
    },
    { id: 4, title: "Email Address", field: "EmailAddress", sortable: true },
    { id: 5, title: "Address", field: "Address", sortable: true },
    {
      id: 6,
      title: "Action",
      render: (item) => {
        return (
          <div style={{ width: 100 }}>
            <a
              onClick={onEdit(item)}
              style={{
                cursor: "pointer",
                color: "green",
                display: "inline-block",
                marginRight: 20,
              }}
            >
              <i className="fas fa-edit" />
            </a>
            {item.CardCode.includes("MR") && (
              <>
                <a
                  onClick={onSyncCustomer(item)}
                  style={{
                    cursor: "pointer",
                    color: "orange",
                    display: "inline-block",
                    marginRight: 20,
                  }}
                >
                  <i className="fas fa-sync" />
                </a>
                <a
                  onClick={onDeleteCustomer(item)}
                  style={{
                    cursor: "pointer",
                    color: "red",
                    display: "inline-block",
                  }}
                >
                  <i className="fas fa-trash" />
                </a>
              </>
            )}
          </div>
        );
      },
    },
  ];
  const columns_product = [
    {
      id: 1,
      title: "Item Description",
      field: "ItemName",
      sortable: true,
      render: (item) => {
        return (
          <a
            onClick={onSelectProduct(item)}
            style={{
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            {item.ItemName}
          </a>
        );
      },
    },
    { id: 2, title: "Model", field: "U_SOL_EX_MODEL", sortable: true },
    {
      id: 3,
      title: "Price/Unit",
      field: "Price",
      render: (item) => {
        return NumberFormat(item.Price);
      },
    },
  ];
  const columns_pph = [
    {
      id: 1,
      title: "Code",
      field: "WTCode",
      sortable: true,
      clickable: true,
    },
    { id: 2, title: "Name", field: "WTName", sortable: true, clickable: true },
    {
      id: 3,
      title: "Rate",
      field: "Rate",
      clickable: true,
      render: (item) => {
        return NumberFormat(item.Rate) + "%";
      },
    },
  ];

  useEffect((_) => {
    initPage();
  }, []);

  useEffect(
    (_) => {
      if (
        info.status_so &&
        info.status_so !== "Closed" &&
        info.status_so !== "Cancelled" &&
        (userInfo.role_name == "SO Payment Verificator" ||
          userInfo.role_name == "SO Payment Verificator - MHC Dealer")
      ) {
        navigate("/salesorder");
        Swal.fire({
          icon: "error",
          title: "Access denied",
          text: "You are not allowed to view this order!",
        });
      }
    },
    [info]
  );

  useEffect(
    (_) => {
      if (refresh) {
        initPage();
      }
    },
    [refresh]
  );

  const orderTypeSelectDisabled = (row_detail) => {
    if (info?.status_so == "Closed" || info?.status_so == "Cancelled") {
      return true;
    } else if (row_detail.free == 1 || row_detail?.paketid) {
      if (row_detail?.paketid?.substring(0, 4) === "PREO") return false;
      else return true;
    } else if (state?.order_no.substring(0, 3) !== "TMP") {
      return true;
    } else if (
      info?.status_so == "Pending" ||
      info?.status_so == "Sync" ||
      info?.status_so == "NotSync"
    )
      return true;
    else if (row_detail.type == "D" || row_detail.type == "R") return true;
    else if (
      row_detail.M_TP_PENJ == "PMR" &&
      includes(row_detail.gudang, "WH-PA")
    )
      return true;

    return false;
  };

  const sendDeductionNotification = async (payload) => {
    let recipients = [];
    //getUserByBranch(userInfo.BPLId).then(res => {
    if (userInfo.legal_affiliates && userInfo.legal_affiliates.length) {
      userInfo.legal_affiliates.forEach((item) =>
        recipients.push({
          name: item.affiliate_name,
          email: item.affiliate_email,
        })
      );
      payload.recipients = recipients;
      //console.log(payload);
      sendMail(payload);
    }
    // });
  };

  const orderTypeTranslator = (order_type) => {
    switch (order_type) {
      case "FGS":
        return "Finish Goods";
      case "PMR":
        return "Pameran";
      case "PMT":
        return "Pameran - Trade In";
      case "SPL":
        return "Solar Panel";
      case "TRD":
        return "Trade In";
      default:
        return "Order Type Not Specified";
    }
  };

  /*useEffect(() => {
        console.log(info)
    }, [info]);*/

  const onSubmitPrice = (price, index, row) => {
    let _detail = [...detail];
    _detail[index].price = price;
    _detail[index].edit_price_allowed = false;
    let _net_disc_amt =
      parseInt(price) * parseInt(_detail[index].qty) -
      parseFloat(_detail[index].net_disc / 100) *
      parseInt(price) *
      parseInt(_detail[index].qty);
    _detail[index].net_disc_amt = _net_disc_amt;
    const response = updateSODetail(row.id, {
      TotalBefDi: price,
    });
    response.then((res) => {
      setState({ ...state, refresh: true });
    });
  };

  const onSubmitDiscount = (disc, index, row) => {
    if (disc < 0 || disc > 100) {
      Swal.fire({
        icon: "error",
        title:
          "Discount percentage value must be between 0 - 100 (inclusive range)",
      });

      return;
    }
    let _detail = [...detail];
    _detail[index].net_disc = disc;
    _detail[index].edit_disc_allowed = false;
    let _net_disc_amt =
      parseInt(_detail[index].price) * parseInt(_detail[index].qty) -
      parseFloat(_detail[index].net_disc / 100) *
      parseInt(_detail[index].price) *
      parseInt(_detail[index].qty);
    _detail[index].net_disc_amt = _net_disc_amt;
    const response = updateSODetail(row.id, {
      M_DISC_1: disc,
    });
    response.then((res) => {
      setState({ ...state, refresh: true });
    });
  };

  const netDiscDisplay = (line_total, net_disc) => {
    if (line_total == 0) {
      if (net_disc == 100) {
        return 100;
      } else return 0;
    } else {
      if (net_disc) {
        if (net_disc == 100) return 100;
        else return parseFloat(net_disc);
      }
      return userInfo.net_discount;
    }
  };

  const onChangeDiscount = (e, index) => {
    let _discs = [...net_discs];
    //let _detail = [...detail];
    //let index = findIndex(_detail, item => item.id == row.id);
    let new_disc = ParseDecimal(e.target.value);
    //_detail[index].price = new_price;
    _discs[index] = new_disc;
    setNetDiscs(_discs);
    //setInfo({ ...info, detail: _detail });
  };

  const onChangePrice = (e, index) => {
    let _prices = [...prices];
    //let _detail = [...detail];
    //let index = findIndex(_detail, item => item.id == row.id);
    let new_price = ParseDecimal(e.target.value);
    //_detail[index].price = new_price;
    _prices[index] = new_price;
    setPrices(_prices);
    //setInfo({ ...info, detail: _detail });
  };

  const initPage = () => {
    const request = [
      getCountryAll({ perpage: 100 }).then((res) => res.data.data),
      getSeries({
        filter: `"ObjectCode":17,"Remark":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getSeriesCustomer({
        filter: `"ObjectCode":2,"DocSubType":C,"Remark":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getDebitorAccount({
        filter: `"Segment_0":1102010,"Segment_2":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getDebitorAccount({
        filter: `"Segment_0":2102010,"Segment_2":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getPPN({
        filter: `"Segment_0":2101550,"Segment_2":${userInfo.BPLName}`,
        add_fields: ['"Segment_0"', '"Segment_2"'],
      }).then((res) => res.data.data),
      getOrderType({ perpage: 100 }).then((res) => res.data.data),
      getExcludeGudang(1).then((res) => res.data.data),
      getTransitWhsCabang(2).then((res) => res.data.data),
      getDealerNonPKP(3).then((res) => res.data.data),
    ];

    if (includes(userInfo.role_name, "MHC Dealer")) {
      request.push(
        getBank({ perpage: 100, filter: `bplid:${userInfo.BPLId}` }).then(
          (res) => res.data.data
        )
      );
    } else {
      request.push(getBank({ perpage: 100 }).then((res) => res.data.data));
    }
    switch (pageState) {
      case "create":
        Promise.all(request)
          .then((results) => {
            const [
              _country,
              _series,
              _seriesCust,
              _debacc,
              _dpclear,
              _ppn,
              _ordertype,
              _exclude_gudang,
              _transit_gudang,
              _dealer_non_pkp,
              _bank,
            ] = results;
            let _newCountry = _country.map((item) => {
              return {
                label: item.Name,
                value: item.Code,
              };
            });

            let _newOrderType = _ordertype.map((item) => {
              return {
                label: item.Name,
                value: item.Code,
              };
            });

            let listppn = _ppn ? [..._ppn] : [];

            if (includes(userInfo.role_name, "MHC Dealer")) {
              listppn = [
                {
                  Name: "PPN keluaran 11%",
                  Rate: "11.000000",
                },
              ];
            }

            setInfo({
              ...info,
              country: _newCountry,
              series: _series?.length > 0 ? _series[0].Series : "",
              series_cust: _seriesCust?.length > 0 ? _seriesCust[0].Series : "",
              ordertype: _newOrderType,
              exclude_gudang: _exclude_gudang,
              transit_gudang: _transit_gudang,
              dealer_non_pkp: _dealer_non_pkp,
              listppn:
                userInfo.u_m_pkp == "Y" ||
                  includes(userInfo.role_name, "MHC Dealer")
                  ? listppn.filter(
                    (item) => parseInt(item.Rate) > 0 && item.Inactive == "N"
                  )
                  : listppn.filter((item) => parseInt(item.Rate) <= 0),
            });

            setTimeout(() => {
              setValue(
                "Series",
                _seriesCust?.length > 0 ? _seriesCust[0].Series : ""
              );
              setValue(
                "DebPayAcct",
                _debacc?.length > 0 ? _debacc[0].AcctCode : ""
              );
              setValue(
                "DpmClear",
                _dpclear?.length > 0 ? _dpclear[0].AcctCode : ""
              );
              setValue("branch", userInfo.BPLId);
              setValue("ECVatGroup", _ppn?.length > 0 ? _ppn[0].Code : "");
            }, 150);
          })
          .catch((err) => {
            let message =
              "Incomplete Dealer-related data. Please try again or contact support!";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;
            Swal.fire({
              icon: "error",
              title: message,
            }).then((_) => {
              navigate("/salesorder");
            });
          });
        break;
      case "edit":
        request.push(getSOHeader(id_so).then((res) => res.data));
        Promise.all(request).then((results) => {
          const [
            _country,
            _series,
            _seriesCust,
            _debacc,
            _dpclear,
            _ppn,
            _ordertype,
            _exclude_gudang,
            _transit_gudang,
            _dealer_non_pkp,
            _bank,
            _so,
          ] = results;
          let _newCountry = _country.map((item) => {
            return {
              label: item.Name,
              value: item.Code,
            };
          });

          let _newOrderType = _ordertype.map((item) => {
            return {
              label: item.Name,
              value: item.Code,
            };
          });
          let _new_bank = _bank.map((item) => {
            let val = item.BankCode;
            let rek = item.Account;
            if (
              includes(userInfo.role_name, "MHC Dealer") &&
              item.is_active == true
            ) {
              val = item.BankCode + " - " + item.Account;
              rek = item.AccountName;
            }
            return {
              label: val,
              value: val,
              rekening: rek,
            };
          });

          let total = 0;
          let total_disk = 0;
          let sum_dpp = 0;
          let maxPpn = Math.max(..._so.detailItem.map((item) => item.VatPrcnt));

          for (const key in _so.detailItem) {
            let _subtotal =
              _so.detailItem[key].LineTotal == 0
                ? 0
                : _so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty;
            total +=
              _so.detailItem[key].LineTotal == 0
                ? 0
                : _so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty;
            let _net_disc = _so.detailItem[key].M_DISC_1
              ? parseFloat(_so.detailItem[key].M_DISC_1) / 100
              : 0;
            let _net_disc_amt = _subtotal - _subtotal * _net_disc;
            // let _campaign_disc = _subtotal > 0 && _so.detailItem[key].LineTotal > 0 ? parseFloat(_so.detailItem[key].M_DISC_2)/ _net_disc_amt : 0;
            let _disk2 = _so.detailItem[key].M_DISC_2_PRC
              ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100
              : 0;
            let _disk3 = _so.detailItem[key].M_DISC_3
              ? parseFloat(_so.detailItem[key].M_DISC_3) / 100
              : 0;
            let _disk4 = _so.detailItem[key].M_DISC_4
              ? parseFloat(_so.detailItem[key].M_DISC_4) / 100
              : 0;
            let _prcntdisc =
              1 - (1 - _net_disc) * (1 - _disk2) * (1 - _disk3) * (1 - _disk4);
            let _dpp = parseFloat(
              _so.detailItem[key].VatPrcnt == 0
                ? _subtotal - _prcntdisc * _subtotal
                : (_subtotal - _prcntdisc * _subtotal) /
                (1 + _so.detailItem[key].VatPrcnt / 100)
            );

            sum_dpp += _dpp;
            total_disk += _prcntdisc * _subtotal;
          }

          let total_payment = 0;
          for (const key in _so.payment) {
            total_payment += parseFloat(_so.payment[key].Amount);
          }

          setWarehouseCount({
            ready_count: _so.ReadyCount,
            indent_count: _so.IndentCount,
          });

          let arr_detail = [];
          let urut = 0;
          let isIndent = false;
          for (const key in _so.detailItem) {
            let deduction_amt = _so.DiscSum;
            deduction_amt = Math.round(deduction_amt);
            let deduct = parseFloat(deduction_amt || 0);
            let subtotal =
              _so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty;
            let subtotal_2 =
              _so.detailItem[key].LineTotal == 0
                ? 0
                : _so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty;

            let pph_selected = _so.detailItem[key].WtLiable;
            let disc_deduction = parseFloat(
              ((deduct + total_disk) / total) * 100
            );

            let net_disc = _so.detailItem[key].M_DISC_1
              ? parseFloat(_so.detailItem[key].M_DISC_1) / 100
              : 0;
            let net_disc_amt = subtotal - subtotal * net_disc;
            // let campaign_disc = subtotal_2 > 0 ? parseFloat(_so.detailItem[key].M_DISC_2)/ net_disc_amt : 0;

            let disk2 = _so.detailItem[key].M_DISC_2_PRC
              ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100
              : 0;
            let disk3 = _so.detailItem[key].M_DISC_3
              ? parseFloat(_so.detailItem[key].M_DISC_3) / 100
              : 0;
            let disk4 = _so.detailItem[key].M_DISC_4
              ? parseFloat(_so.detailItem[key].M_DISC_4) / 100
              : 0;
            let delta_disc =
              (1 - net_disc) * (1 - disk2) * (1 - disk3) * (1 - disk4);
            delta_disc = delta_disc.toFixed(4);
            let prcntdisc = 1 - delta_disc;
            prcntdisc = prcntdisc.toFixed(4);
            let disc_total = subtotal_2 * (parseFloat(prcntdisc) / 100);
            let dpp = parseFloat(
              _so.detailItem[key].VatPrcnt == 0
                ? subtotal_2 - prcntdisc * subtotal
                : (subtotal_2 - prcntdisc * subtotal) /
                (1 + _so.detailItem[key].VatPrcnt / 100)
            );
            dpp = dpp < 0 ? 0 : dpp;
            let prcnt_bef = (deduct / sum_dpp) * 100;
            let am_ppn = parseFloat(
              dpp * (_so.detailItem[key].VatPrcnt / 100)
            ).toFixed(2);
            let am_ppn_after_disc = am_ppn - am_ppn * (prcnt_bef / 100);
            urut += _so.detailItem[key].LineTotal == 0 ? 0 : 1;

            let am_pph = dpp - (dpp * prcnt_bef) / 100;
            const is_delivery =
              _so.detailItem[key].TypeWhs == "I"
                ? true
                : _so.detailItem[key].Delivery;

            arr_detail.push({
              urut,
              grade: _so.detailItem[key].Grade,
              itemname: _so.detailItem[key].Dscription,
              itemno: _so.detailItem[key].ItemCode,
              price: _so.detailItem[key].TotalBefDi,
              qty: _so.detailItem[key].Qty,
              type: _so.detailItem[key].TypeWhs,
              paketid: _so.detailItem[key].M_KD_CMPG,
              paket_name: _so.detailItem[key].M_KET_CMPG,
              gudang: _so.detailItem[key].WHS,
              free: _so.detailItem[key].LineTotal == 0 ? 1 : 0,
              id: _so.detailItem[key].id,
              ppn: _so.detailItem[key].VatPrcnt,
              delivery: is_delivery,
              pph: _so.detailItem[key].WtLiable,
              amount_ppn: am_ppn_after_disc,
              amount_pph:
                pph_selected == "y"
                  ? Math.round(am_pph * (info.pph_rate / 100))
                  : 0,
              amount_dpp: dpp,
              amount_discount: prcntdisc * subtotal,
              net_disc: netDiscDisplay(
                _so.detailItem[key].LineTotal,
                _so.detailItem[key].M_DISC_1
              ),
              net_disc_amt,
              disc_2: parseFloat(_so.detailItem[key].M_DISC_2),
              disc_deduction: disc_deduction,
              disc_total: disc_total,
              final_price:
                net_disc_amt - parseFloat(_so.detailItem[key].M_DISC_2),
              M_TP_PENJ: _so.detailItem[key].M_TP_PENJ,
              disc_prcnt: _so.detailItem[key].DiscPrcnt,
              M_DISC_1: _so.detailItem[key].M_DISC_1,
              M_DISC_2_PRC: _so.detailItem[key].M_DISC_2_PRC,
              total_bef_di: _so.detailItem[key].TotalBefDi,
              ShipToDesc: _so.detailItem[key].ShipToDesc,
              ShipToCode: _so.detailItem[key].ShipToCode,
              additional_address: _so.detailItem[key].additional_address,
              additional_receiver: _so.detailItem[key].additional_receiver,
              additional_city: _so.detailItem[key].additional_city,
              additional_county: _so.detailItem[key].additional_county,
              additional_phone: _so.detailItem[key].additional_phone,
            });
            if (_so.detailItem[key].TypeWhs === "I") {
              isIndent = true;
            }
            const harga = [...prices];
            const diskon = [...net_discs];
            arr_detail.forEach((item, index) => {
              harga[index] = item.price;
              diskon[index] = item.net_disc;
              item.edit_price_allowed = false;
            });

            setPrices(harga);
            setNetDiscs(diskon);
          }
          let getCustomerFunc = () =>
            getCustomer({ filter: `CardCode:${_so.CardCode}` });
          if (
            userInfo.role_name == "SO Payment Verificator" ||
            userInfo.role_name == "SO Payment Verificator - MHC Dealer"
          ) {
            getCustomerFunc = () =>
              getCustomerAll({ filter: `CardCode:${_so.CardCode}` });
          }

          const reqMore = [
            getCustomerFunc().then((res) => res.data.data),
            getDebitorAccount({
              filter: `"Segment_0":1102010,"Segment_2":${userInfo.BPLName}`,
            }).then((res) => res.data.data),
            getDebitorAccount({
              filter: `"Segment_0":2102010,"Segment_2":${userInfo.BPLName}`,
            }).then((res) => res.data.data),
            cekPOExist(_so.DocNumSO).then((res) => res.data),
          ];
          if (deductionType && deductionType.current)
            deductionType.current.value = "Amount";
          Promise.all(reqMore).then((results) => {
            const [_customer, _debacc_cust, _dpclear_cust, _po] = results;
            if (_customer.length > 0) {
              getProvince(_customer[0].county_code).then((res) => {
                const _prov = res.data.data.map((item) => {
                  return {
                    label: item.U_SOL_CITY_NAME,
                    value: item.U_SOL_CITY_CODE,
                  };
                });
                // console.log(_prov);
                const hitungan = Calculate(arr_detail);
                const deduksi = _so.DiscSum;
                let listppn = _ppn;
                if (includes(userInfo.role_name, "MHC Dealer")) {
                  listppn = [
                    {
                      Name: "PPN keluaran 11%",
                      Rate: "11.000000",
                    },
                  ];
                }

                setInfo({
                  ...info,
                  legal: _so.legal_stuff,
                  user_information: !includes(userInfo.role_name, "MHC Dealer")
                    ? _so.user_info
                    : userInfo,
                  listppn:
                    userInfo.u_m_pkp == "Y" ||
                      includes(userInfo.role_name, "MHC Dealer")
                      ? listppn.filter((item) => parseInt(item.Rate) > 0)
                      : listppn.filter((item) => parseInt(item.Rate) <= 0),
                  bank: _new_bank,
                  country: _newCountry,
                  series: _series?.length > 0 ? _series[0].Series : "",
                  series_cust:
                    _seriesCust?.length > 0 ? _seriesCust[0].Series : "",
                  ordertype: _newOrderType,
                  exclude_gudang: _exclude_gudang,
                  transit_gudang: _transit_gudang,
                  dealer_non_pkp: _dealer_non_pkp,
                  detail: arr_detail,
                  created_date: _so.created_date,
                  kode_customer: _so.CardCode,
                  nama_customer: _so.CardName,
                  phone: _customer[0].Phone1,
                  email: _customer[0].EmailAddress,
                  address: _customer[0].Address,
                  province: _prov,
                  status_so: _so.Status,
                  payment_verification_date: _so.payment_verification_date,
                  payment_verified: _so.payment_verified,
                  payment_verified_by: _so.payment_verified_by,
                  delivery_date: moment(_so.DocDueDate).format("YYYY-MM-DD"),
                  deduction: Math.round(parseFloat(deduksi || 0)),
                  pph_rate: parseFloat(_so.Rate || 0),
                  total_before_discount_with_free: hitungan.subtotal,
                  total: hitungan.subtotal2,
                  total_ppn: hitungan.amount_ppn,
                  total_pph: hitungan.amount_pph,
                  total_dpp: hitungan.amount_dpp,
                  total_discount: hitungan.amount_disc,
                  sales_remark: _so.sales_remark,
                  grand_total: _so.DocTotal,
                  npwp: _so.npwp,
                });
                const _items = _so.payment.length
                  ? _so.payment.map((e) => ({
                    index: e.id,
                    bank: e.BANK,
                    payment_type: e.TypePayment,
                    nominal_payment: parseFloat(e.Amount),
                    img_upload: e.image_name,
                    isSave: true,
                    File: null,
                    card_number: e.card_number,
                    line_payment: linePayment,
                    invoice_url: e.invoice_url,
                  }))
                  : [];
                setShowBankCardnumber(
                  _items.length > 0 && _items[0].payment_type !== "IPG"
                    ? true
                    : false
                );
                if (_so.payment_image) {
                  _items.img_upload = _so.payment_image;
                }

                let isLocked =
                  _so.DocNumSO.substring(0, 3) == "TMP"
                    ? false
                    : _so.Status == "Pending" ||
                      _so.Status == "Open" ||
                      _so.Status == "Closed" ||
                      _so.Status == "Sync" ||
                      _so.Status == "NotSync"
                      ? true
                      : false;

                let payment_show = showPayment(_so.DocNumSO, _so.Status);

                if (_items.length <= 0) {
                  _items.push({
                    index: uuid(),
                    bank: bank.length > 1 ? bank[0].value : "MANDIRI",
                    payment_type: "IPG",
                    nominal_payment: ParseDecimal(_so.DocTotal),
                    img_upload: "",
                    File: null,
                    isSave: false,
                    line_payment: linePayment,
                    card_number: null,
                  });
                  total_payment = ParseDecimal(_so.DocTotal);
                }

                setOrderNumber(_so.DocNumSO);

                setState({
                  ...state,
                  payment_show,
                  order_id: id_so,
                  order_no: _so.DocNumSO,
                  docnum: _so.DocNum ? _so.DocNum : "-",
                  note_approval: _so.descstatus,
                  approved_date: _so.approved_date,
                  province: _customer[0].county_code,
                  city: _customer[0].city_code,
                  ShipToCode: _customer[0].address_code,
                  locked: isLocked,
                  listPayment: _items,
                  total_payment: total_payment,
                  refresh: false,
                  deduction_amount: Math.round(parseFloat(deduksi || 0)),
                  deduction_type: "Amount",
                  showbtnresubmitpo:
                    isLocked &&
                      _so.Status != "Pending" &&
                      isIndent &&
                      _po.data.length === 0
                      ? true
                      : false,
                  po_list: _po.data,
                  kupon_kode: _so.voucher_code,
                  sales_name: _so.created_by_name,
                  ppn_selected: maxPpn,
                  ip_doc_entry: _so.ip_doc_entry,
                  // with_ip: _so.with_ip, comment out temporary 
                  with_ip: false
                });
              });
            } else {
              setInfo({
                ...info,
                country: _newCountry,
                series: _series?.length > 0 ? _series[0].Series : "",
                ordertype: _newOrderType,
                exclude_gudang: _exclude_gudang,
                transit_gudang: _transit_gudang,
                detail: arr_detail,
                kode_customer: _so.CardCode,
                nama_customer: _so.CardName,
              });
              setState({
                ...state,
                refresh: false,
                order_id: id_so,
                locked:
                  id_so.substring(0, 3) == "TMP"
                    ? false
                    : _so.Status == "Pending" ||
                      _so.Status == "Open" ||
                      _so.Status == "Closed"
                      ? true
                      : false,
              });
            }

            setTimeout(() => {
              setValue(
                "Series",
                _seriesCust?.length > 0 ? _seriesCust[0].Series : ""
              ); //series cust
              // setValue('Series', _series.length > 0 ? _series[0].Series : '' ); //series so
              setValue(
                "DebPayAcct",
                _debacc_cust?.length > 0 ? _debacc_cust[0].AcctCode : ""
              );
              setValue(
                "DpmClear",
                _dpclear_cust?.length > 0 ? _dpclear_cust[0].AcctCode : ""
              );
              setValue("branch", userInfo.BPLId);
              setValue("ECVatGroup", _ppn?.length > 0 ? _ppn[0].Code : "");
            }, 150);
          });
        });
        break;
    }
  };

  useEffect(() => {
    if (warehouseCount.ready_count > 0 && warehouseCount.indent_count > 0) {
      getAddDocsStatus("both", state.order_no).then((res) => {
        console.log(res);
      });
    }
  }, [warehouseCount]);

  const onShowModal = () => {
    $("#modal-detail").modal();
    setValue("GroupCode", userInfo.GroupCode);
    setValue("WTCode", "");
    setValue("CardType", "C");
    setValue("validFor", "Y");
    mTableC.current.refresh();
  };

  const onAddData = () => {
    onReset();
    setState({ ...state, customer: {} });
    $("#modal-form").modal();
  };

  const onReset = () => {
    setValue("CardName", "");
    setValue("Phone1", "");
    setValue("EmailAddress", "");
    setValue("Address", "");
    setValue("GroupCode", userInfo.GroupCode);
    setValue("WTCode", "");
    setValue("CardType", "C");
    setValue("validFor", "Y");
  };

  const onImageChange = (e) => {
    const [file] = e.target.files;

    if (file) {
      if (
        file.type !== "image/png" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg"
      ) {
        Swal.fire({
          icon: "error",
          title:
            "That file extension is not allowed (only .png, .jpeg, or .jpg)",
        });
        return;
      }
      if (file.size <= 1000000) {
        listPayment.img_upload = URL.createObjectURL(file);
        listPayment.File = file;
        setState({ ...state, listPayment });
      } else {
        Swal.fire({
          icon: "error",
          title: "The image size is too large",
        });
      }
    }
  };

  const onSelectImage = (i) => {
    $("#payment-upload").click();
  };

  const onSyncCustomer = (item) => () => {
    setState({ ...state, loading: true });
    syncCustomer(item.CardCode)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `Sync Customer success!`,
        }).then(() => {
          mTableC.current.refresh();
        });
      })
      .catch(({ response }) => {
        const { message } = response?.data;
        Swal.fire({
          icon: "error",
          title: `Sync Customer error!`,
          text: message,
        });
      })
      .finally(() => {
        setState({ ...state, loading: false });
      });
  };

  const onDeleteCustomer = (item) => () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-modena",
        cancelButton: "btn btn-readonly mr-3",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Confirmation",
        text:
          "Are you sure Delete this Customer Code " +
          item.CardCode +
          " - " +
          item.CardName +
          " ?",
        confirmButtonColor: "#3085d6",
        showCancelButton: true,
        confirmButtonText: "Sure",
        reverseButtons: true,
      })
      .then(({ isConfirmed }) => {
        if (isConfirmed) {
          setState({ ...state, loading: true });
          deleteCustomer(item.CardCode)
            .then((res) => {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: `Delete Customer success!`,
              }).then(() => {
                mTableC.current.refresh();
              });
            })
            .catch(({ response }) => {
              const { message } = response?.data;
              Swal.fire({
                icon: "error",
                title: `Delete Customer error!`,
                text: message,
              });
            })
            .finally(() => {
              setState({ ...state, loading: false });
            });
        }
      });
  };

  const onSelect = (item) => () => {
    if (item.CardCode.includes("MR")) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Customer Code",
        text: "Customer Code must be synchronized with SAP, please synchronize first.",
      });
      return;
    }
    if (!info.delivery_date) {
      Swal.fire({
        icon: "error",
        title: "Delivery date is required",
        text: "Please select a delivery date before proceeding.",
      });
      return;
    }
    const reqProvice = getProvince(item.county_code).then(
      (res) => res.data.data
    );
    const reqCustomer = getCustomer({
      filter: `CardCode:${item.CardCode}`,
    }).then((res) => res.data.data);

    Promise.all([reqProvice, reqCustomer]).then((results) => {
      const [_province, _cust] = results;

      if (info.series == "") {
        Swal.fire({
          icon: "error",
          title: "Please select series first !!, series is empty",
        });
        return;
      }

      let payload = {
        Series: includes(userInfo.role_name, "MHC Dealer") ? 0 : info.series,
        CardCode: item.CardCode,
        CardName: item.CardName,
        EmailAddress: item.EmailAddress,
        Status: "Open",
        ShipToCode: item.address_code,
        BPLId: userInfo.BPLId,
        BPLName: userInfo.BPLName,
        shipping_name: _cust.length > 0 ? _cust[0].CardName : "",
        shipping_address: _cust.length > 0 ? _cust[0].Address : "",
        shipping_city: _cust.length > 0 ? _cust[0].City : "",
        shipping_county: _cust.length > 0 ? _cust[0].County : "",
        shipping_phone: _cust.length > 0 ? _cust[0].Phone1 : "",
        shipping_mobilephone: _cust.length > 0 ? _cust[0].Phone1 : "",
        // M_TP_PENJ: state.order_type,
        DocDueDate: info.delivery_date,
      };

      if (!includes(userInfo.role_name, "MHC Dealer")) {
        payload["mi_cardcode"] = userInfo.MI_cardcode[0].U_M_BP_CODE_MI;
        payload["mhc_cardcode"] = userInfo.MI_cardcode[0].CardCode;
        payload["mhc_cardname"] = userInfo.MI_cardcode[0].CardName;
      }

      createSOHeader(payload)
        .then((res) => {
          const _data = res.data;
          const _prov = _province.map((item) => {
            return {
              label: item.U_SOL_CITY_NAME,
              value: item.U_SOL_CITY_CODE,
            };
          });

          setInfo({
            ...info,
            kode_customer: item.CardCode,
            nama_customer: item.CardName,
            phone: item.Phone1,
            email: item.EmailAddress,
            address: item.Address,
            province: _prov,
          });

          setState({
            ...state,
            order_id: _data.id,
            order_no: _data.DocNumSO,
            ShipToCode: item.address_code,
            province: item.county_code,
            city: item.city_code,
          });

          $("#modal-detail").modal("hide");
          navigate("/salesorder/edit/" + _data.id);
          setTimeout(() => {
            setState({ ...state, refresh: true });
          }, 500);
        })
        .catch(({ response }) => {
          Swal.fire({
            icon: "error",
            title: "Sales Order Creation failed",
            text: response.data.message,
          });
        });
    });
  };

  useEffect(() => {
    if (state.order_id) {
      let arr_detail = [];
      getSOHeader(state.order_id).then((res) => {
        if (res.status == 200) {
          let items = res.data.detailItem;
          let total = 0;
          let total_disk = 0;
          let sum_dpp = 0;
          for (const key in items) {
            let _subtotal =
              items[key].LineTotal == 0
                ? 0
                : items[key].TotalBefDi * items[key].Qty;
            total +=
              items[key].LineTotal == 0
                ? 0
                : items[key].TotalBefDi * items[key].Qty;
            let _net_disc = items[key].M_DISC_1
              ? parseFloat(items[key].M_DISC_1) / 100
              : 0;
            let _net_disc_amt = _subtotal - _subtotal * _net_disc;
            // let _campaign_disc = _subtotal > 0 && items[key].LineTotal > 0 ? parseFloat(items[key].M_DISC_2)/ _net_disc_amt : 0;

            let _disk2 = items[key].M_DISC_2_PRC
              ? parseFloat(items[key].M_DISC_2_PRC) / 100
              : 0;
            let _disk3 = items[key].M_DISC_3
              ? parseFloat(items[key].M_DISC_3) / 100
              : 0;
            let _disk4 = items[key].M_DISC_4
              ? parseFloat(items[key].M_DISC_4) / 100
              : 0;
            let _prcntdisc =
              1 - (1 - _net_disc) * (1 - _disk2) * (1 - _disk3) * (1 - _disk4);
            let _dpp = parseFloat(
              items[key].VatPrcnt == 0
                ? _subtotal - _prcntdisc * _subtotal
                : (_subtotal - _prcntdisc * _subtotal) /
                (1 + items[key].VatPrcnt / 100)
            );

            sum_dpp += _dpp;
            total_disk += _prcntdisc * _subtotal;
          }
          let urut = 0;

          for (const key in items) {
            let subtotal = items[key].TotalBefDi * items[key].Qty;
            let subtotal_2 =
              items[key].LineTotal == 0
                ? 0
                : items[key].TotalBefDi * items[key].Qty;
            let pph_selected = items[key].WtLiable;
            let disc_deduction = parseFloat(
              ((deduction + total_disk) / total) * 100
            );
            let net_disc = items[key].M_DISC_1
              ? parseFloat(items[key].M_DISC_1) / 100
              : 0;
            let net_disc_amt = subtotal - subtotal * net_disc;
            let campaign_disc =
              subtotal_2 > 0
                ? parseFloat(items[key].M_DISC_2) / net_disc_amt
                : 0;
            // let prcntdisc = net_disc + ((1-net_disc) * campaign_disc);
            let disk2 = items[key].M_DISC_2_PRC
              ? parseFloat(items[key].M_DISC_2_PRC) / 100
              : 0;
            let disk3 = items[key].M_DISC_3
              ? parseFloat(items[key].M_DISC_3) / 100
              : 0;
            let disk4 = items[key].M_DISC_4
              ? parseFloat(items[key].M_DISC_4) / 100
              : 0;
            let delta_disc =
              (1 - net_disc) * (1 - disk2) * (1 - disk3) * (1 - disk4);
            delta_disc = delta_disc.toFixed(4);
            let prcntdisc = 1 - delta_disc;
            prcntdisc = prcntdisc.toFixed(4);
            //console.log(prcntdisc);
            let disc_total = subtotal_2 * (parseFloat(prcntdisc) / 100);
            let dpp = parseFloat(
              items[key].VatPrcnt == 0
                ? subtotal_2 - prcntdisc * subtotal
                : (subtotal_2 - prcntdisc * subtotal) /
                (1 + items[key].VatPrcnt / 100)
            );
            dpp = dpp <= 0 ? 0 : dpp;
            let prcnt_bef = (deduction / sum_dpp) * 100;
            let am_ppn = parseFloat(dpp * (items[key].VatPrcnt / 100)).toFixed(
              2
            );
            let am_ppn_after_disc = am_ppn - am_ppn * (prcnt_bef / 100);

            let am_pph = dpp - (dpp * prcnt_bef) / 100;

            urut += items[key].LineTotal == 0 ? 0 : 1;
            arr_detail.push({
              urut,
              grade: items[key].Grade,
              itemname: items[key].Dscription,
              itemno: items[key].ItemCode,
              price: items[key].TotalBefDi,
              qty: items[key].Qty,
              type: items[key].TypeWhs,
              paketid: items[key].M_KD_CMPG,
              paket_name: items[key].M_KET_CMPG,
              gudang: items[key].WHS,
              free: items[key].LineTotal == 0 ? 1 : 0,
              id: items[key].id,
              ppn: items[key].VatPrcnt,
              delivery: items[key].Delivery,
              pph: pph_selected,
              amount_ppn: am_ppn_after_disc,
              amount_pph:
                pph_selected == "y"
                  ? Math.round(am_pph * (info.pph_rate / 100))
                  : 0,
              amount_dpp: dpp,
              amount_discount: prcntdisc * subtotal,
              net_disc: netDiscDisplay(
                items[key].LineTotal,
                items[key].M_DISC_1
              ),
              net_disc_amt,
              disc_2: parseFloat(items[key].M_DISC_2),
              disc_deduction: disc_deduction,
              disc_total: disc_total,
              final_price: net_disc_amt - parseFloat(items[key].M_DISC_2),
              M_TP_PENJ: items[key].M_TP_PENJ,
              disc_prcnt: items[key].DiscPrcnt,
              M_DISC_1: items[key].M_DISC_1,
              M_DISC_2_PRC: items[key].M_DISC_2_PRC,
              total_bef_di: items[key].TotalBefDi,
              ShipToDesc: items[key].ShipToDesc,
              ShipToCode: items[key].ShipToCode,
              additional_address: items[key].additional_address,
              additional_receiver: items[key].additional_receiver,
              additional_city: items[key].additional_city,
              additional_county: items[key].additional_county,
              additional_phone: items[key].additional_phone,
            });
          }
          const hitungan = Calculate(arr_detail);
          //console.log(deduction);
          //const deduction_val = hitungan.amount_ppn > 0? deduction : deduction *1.11
          const deduction_val = deduction;
          setInfo({
            ...info,
            detail: arr_detail,
            total_before_discount_with_free: hitungan.subtotal,
            total: hitungan.subtotal2,
            total_ppn: hitungan.amount_ppn,
            total_pph: hitungan.amount_pph,
            total_dpp: hitungan.amount_dpp,
            total_discount: hitungan.amount_disc,
            grand_total: res.data.DocTotal,
          });
        }
      });
    }
  }, [state.order_id]);

  let totalMZF = info.detail
    .map((item) => item.final_price)
    .reduce((prev, next) => prev + next, 0);
  let total =
    /*info.total_before_discount_with_free-total_discount*/ totalMZF -
    deduction;

  let campaign_net_disc =
    info.total_before_discount_with_free - Math.round(total) - deduction;

  let total_before_tax =
    userInfo.u_m_pkp == "Y" || includes(userInfo.role_name, "MHC Dealer")
      ? Math.round(
        info.total_before_discount_with_free -
        campaign_net_disc -
        deduction -
        (info.total_before_discount_with_free -
          campaign_net_disc -
          deduction) /
        (state.ppn_selected / 100 + 1)
      )
      : total;

  const onSelectProduct = (item) => () => {
    setStateGrade("A");
    setStateEventType("FGS");
    item.Grade = "A";
    $('[name="inlineRadioOptions"]').prop("checked", false);
    let payload = {
      items: [
        {
          ItemCode: item.ItemCode,
        },
      ],
    };

    if (!includes(userInfo.role_name, "MHC Dealer")) {
      payload["Whs"] = [
        {
          WhsCode:
            userInfo.user_warehouse_stock.match(/[0-9]+/g) != null
              ? userInfo.user_warehouse_stock.match(/[0-9]+/g)[0]
              : "",
        },
      ];
    }

    setState({ ...state, processing: true });
    getStok(payload)
      .then((res) => {
        //console.log(res.data);
        let indent_whs = [];
        let dataStok = res.data;
        dataStok = dataStok.reverse();
        let ready = 0;
        let indent = 0;
        let display = 0;
        let gd_ready = "";
        let gd_display = "";
        let gd_indent = "";
        let current_indent = 0;
        let current_display = 0;
        let current_ready = 0;
        let locked = "N";
        let qty_unlock = 0;

        let cardcode = userInfo.MI_cardcode;

        const infoCardcode = cardcode.find(item => item.U_M_TP_TRSKS === "FGS");
        const codeCardcode = infoCardcode ? infoCardcode.U_M_BP_CODE_MI : null;
        const indexTransit = info.transit_gudang.findIndex(
          (item) => item.code_id == codeCardcode
        );

        let tr_gudang = info?.transit_gudang;

        for (const key in dataStok) {

          const index = info.exclude_gudang.findIndex(
            (item) => item.code_name == info.user_information.BPLName
          );

          dataStok[key].Transit = false;

          if (dataStok[key].Type == "Display") {
            display = dataStok[key].OnHand;
            gd_display = dataStok[key].WhsCode;
          } else if (
            dataStok[key].Type == "Indent" &&
            // dataStok[key].OnHand > 0 &&
            ((index < 0 && dataStok[key].WhsCode != "WH-SDFGA") || index >= 0)
          ) {
            indent_whs.push(dataStok[key]);
          } else if (
            dataStok[key].Type == "Indent" &&
            dataStok[key].Locked == "Y"
          ) {
            indent_whs.push(dataStok[key]);
            qty_unlock = dataStok[key].OnHandReal;
            locked = dataStok[key].Locked;
          } else if (dataStok[key].Type == "Ready") {
            ready = dataStok[key].OnHand;
            gd_ready = dataStok[key].WhsCode;
          }
        }

        if (indent_whs.length) {
          if (indexTransit >= 0) {
            const mappedGudang = tr_gudang
              .filter((gudang) => gudang.code_id.trim() === codeCardcode)
              .map((gudang) => ({
                ItemCode: indent_whs[0].ItemCode,
                WhsCode: gudang.code_name.trim(),
                OnHand: 0,
                Type: "Indent",
                Locked: "N",
                OnHandReal: 0,
                Transit: true,
                CardCode: gudang.code_id
              }));

            indent_whs.push(...mappedGudang); // Spread operator to add all items
          }

          indent = indent_whs[0].OnHand;
          gd_indent = indent_whs[0].WhsCode;

          setIndentWarehouses(indent_whs);
        }

        detail.forEach((datum) => {
          if (datum.itemno == item.ItemCode) {
            if (datum.type == "I" && datum.grade == item.Grade)
              current_indent += parseInt(datum.qty);
            else if (datum.type == "R") current_ready += parseInt(datum.qty);
            else current_display += parseInt(datum.qty);
          }
        });

        setState({
          ...state,
          showProduct: true,
          processing: false,
          opsiProduct: {
            itemname: item.ItemName,
            itemno: item.ItemCode,
            price: item.Price,
            qty: ready - current_ready > 0 ? 1 : 0,
            uom: item.BuyUnitMsr,
            type: ready - current_ready > 0 ? "R" : "",
            paketid: "",
            qty_indent: indent - current_indent,
            qty_ready: ready - current_ready,
            qty_display: display - current_display,
            gudang_display: gd_display,
            gudang_indent: gd_indent,
            gudang_ready: gd_ready,
            gudang_selected: ready - current_ready > 0 ? gd_ready : "",
            qty_selected: ready - current_ready > 0 ? ready - current_ready : 0,
            grade: "A",
            locked: locked,
            qty_unlock,
          },
        });
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
        setState({ ...state, processing: false });
      });
    document.querySelector("#modal-product-detail").style.display = "block";
    document.querySelector("#modal-product-preorder").style.display = "none";
  };

  const loadStok = (grade, soEventType) => {
    let {
      itemname,
      itemno,
      price,
      uom,
      qty_ready,
      qty_display,
      gudang_display,
      gudang_ready,
      qty_selected,
      qty_indent,
    } = state.opsiProduct;
    let payload = {
      items: [
        {
          ItemCode: itemno,
        },
      ],
      grade,
    };
    if (soEventType == "PMR") {
      payload["gudang"] = userInfo.kode_gudang_pameran_a;
    }

    if (!includes(userInfo.role_name, "MHC Dealer")) {
      payload["Whs"] = [
        {
          WhsCode:
            userInfo.user_warehouse_stock.match(/[0-9]+/g) != null
              ? userInfo.user_warehouse_stock.match(/[0-9]+/g)[0]
              : "",
        },
      ];
    }
    setState({ ...state, processing: true });
    getStok(payload)
      .then((res) => {
        let indent_whs = [];
        let dataStok = res.data;
        dataStok = dataStok.reverse();
        let ready = 0;
        let indent = 0;
        let display = 0;
        let gd_ready = "";
        let gd_display = "";
        let gd_indent = "";
        let current_indent = 0;
        let current_display = 0;
        let current_ready = 0;
        let locked = "N";
        let qty_unlock = 0;

        for (const key in dataStok) {
          if (dataStok[key].Type == "Display") {
            display = dataStok[key].OnHand;
            gd_display = dataStok[key].WhsCode;
          } else if (
            dataStok[key].Type == "Indent" &&
            dataStok[key].OnHand > 0
          ) {
            indent_whs.push(dataStok[key]);
          } else if (dataStok[key].Type == "Ready") {
            ready = dataStok[key].OnHand;
            gd_ready = dataStok[key].WhsCode;
          }
        }
        if (indent_whs.length) {
          indent = indent_whs[0].OnHand;
          gd_indent = indent_whs[0].WhsCode;
        }
        setIndentWarehouses(indent_whs);

        detail.forEach((datum) => {
          if (datum.itemno == itemno) {
            if (datum.type == "I" && datum.grade == grade)
              current_indent += parseInt(datum.qty);
            else if (datum.type == "R") current_ready += parseInt(datum.qty);
            else current_display += parseInt(datum.qty);
          }
        });

        setState({
          ...state,
          showProduct: true,
          processing: false,
          opsiProduct: {
            itemname,
            itemno,
            price,
            qty: indent - current_indent > 0 ? 1 : 0,
            uom,
            type: "I",
            paketid: "",
            qty_indent: indent - current_indent,
            qty_ready: ready - current_ready,
            qty_display: display - current_display,
            gudang_display: gd_display,
            gudang_indent: gd_indent,
            gudang_ready: gd_ready,
            gudang_selected: indent - current_indent > 0 ? gd_indent : "",
            qty_selected:
              indent - current_indent > 0 ? indent - current_indent : 0,
            grade,
            locked: locked,
            qty_unlock,
          },
        });
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
        setState({ ...state, processing: false });
      });
  };

  const onChangeSOEventType = (e) => {
    let soEventType = e.target.value;
    let cardcodes = [...userInfo.MI_cardcode];
    cardcodes = cardcodes.filter((item) => {
      return item.CardName.indexOf(e.target.value) > -1;
    });
    if (cardcodes.length <= 0) {
      Swal.fire({
        icon: "error",
        title: "You don't have any cardcode for this event type",
      });
      return;
    }
    $('[name="inlineRadioOptions"]').prop("checked", false);
    setStateEventType(soEventType);
    loadStok($("#soItemGrade").val(), soEventType);
  };

  const onChangeGrade = (e) => {
    let grade = e.target.value;
    //let {itemno, itemname, price, uom} = state.opsiProduct;
    $('[name="inlineRadioOptions"]').prop("checked", false);
    setStateGrade(grade);
    loadStok(grade, $("#soEventType").val());
  };

  //useEffect(() => console.log(indent_warehouses), [indent_warehouses])
  const onChangeNominal = (e, i) => {
    const index = listPayment.findIndex((item) => item.index == i);
    if (index > -1) {
      listPayment[index].nominal_payment = e.target.value.split(".").join("");
      let subtotal = 0;
      for (const element of listPayment) {
        subtotal += parseFloat(element.nominal_payment);
      }
      setState({ ...state, listPayment, total_payment: total });
    }
  };
  const onChangePaymentType = (e, i) => {
    const index = listPayment.findIndex((item) => item.index == i);
    if (index > -1) {
      listPayment[index].payment_type = e.value;
      setState({ ...state, listPayment });
      if (e.value != "IPG") {
        setShowBankCardnumber(true);
      } else {
        setShowBankCardnumber(false);
      }
    }
  };
  const onChangeBank = (e, i) => {
    const index = listPayment.findIndex((item) => item.index == i);
    if (index > -1) {
      listPayment[index].bank = e.value;
      setState({ ...state, listPayment });
    }
  };

  const onChangeCardNumber = (e, i) => {
    const index = listPayment.findIndex((item) => item.index == i);
    if (index > -1) {
      listPayment[index].card_number = e.target.value;
      setState({ ...state, listPayment });
    }
  };

  const setChange = (e) => {
    var index = e.nativeEvent.target.selectedIndex;
    getProvince(e.target.value).then((res) => {
      let _prov = res.data.data.map((item) => {
        return {
          label: item.U_SOL_CITY_NAME,
          value: item.U_SOL_CITY_CODE,
        };
      });
      setState({ ...state, city: [], province: e.target.value });
      setValue("form_province", e.target.value);
      setValue("City", "");
      setValue("form_city", "");
      setInfo({
        ...info,
        province: _prov,
        province_label: e.nativeEvent.target[index].text,
        city_label: "",
      });
    });
  };

  const setChangeCity = (e) => {
    var index = e.nativeEvent.target.selectedIndex;
    setValue("City", e.nativeEvent.target[index].text);
    setInfo({ ...info, city_label: e.nativeEvent.target[index].text });
  };
  const setChangeOrderType = (e) => {
    setState({ ...state, order_type: e.value });
  };
  const setChangeProv = (e) => {
    getListCity(e.value, 1);
  };

  const getListCity = (e, isEvent) => {
    getProvince(e).then((res) => {
      let _prov = res.data.data.map((item) => {
        return {
          label: item.U_SOL_CITY_NAME,
          value: item.U_SOL_CITY_CODE,
        };
      });
      setState({ ...state, city: _prov[0].value, province: e });
      setInfo({ ...info, province: _prov });
    });
  };
  const onDateDeliveryChange = (event) => {
    let tgl = moment(event.target.value).format("YYYY-MM-DD");
    let today = moment();
    if (today.diff(tgl, "days") > 0) {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Delivery date cannot be lower than today..!",
      });
      return;
    }
    if (state.order_id !== null) {
      const response_so_update = updateSO(state.order_id, {
        DocDueDate: event.target.value,
      });
      response_so_update.then((res_so) => {
        setInfo({ ...info, delivery_date: tgl });
      });
    } else {
      setInfo({ ...info, delivery_date: event.target.value });
    }
  };

  const addProductDetail = (item) => {
    setState({ ...state, enable_add_product_detail: false });

    const maxPpnRate = Math.max(
      ...listppn
        .filter((ppn) => ppn.Inactive == "N")
        .map((ppn) => parseFloat(ppn.Rate))
    );
    const maxPpnIndex = listppn.findIndex(
      (ppn) => parseFloat(ppn.Rate) === maxPpnRate
    );

    let rate_ppn = listppn.length > 0 ? maxPpnRate : 0;
    let vatGroup = listppn.length > 0 ? listppn[maxPpnIndex].Code : "";

    if (item.qty <= 0) {
      Swal.fire({
        icon: "error",
        title: "Zero quantity is not allowed..!",
        text: "Please input the quantity first..!",
      }).then(() => {
        stopProcessing();
        setState({ ...state, enable_add_product_detail: true });
      });
    } else {
      let payload = {
        tr_salesorder_h_id: state.order_id,
        ItemCode: item.itemno,
        Dscription: item.itemname,
        TotalBefDi: item.price,
        VatPrcnt: rate_ppn,
        VatGroup: vatGroup,
        Qty: item.qty,
        UomCode: item.uom,
        WHS: item.gudang_selected,
        ShipToCode: state.ShipToCode,
        Delivery: 0,
        M_DISC_1: userInfo.net_discount,
        M_DISC_2: 0,
        M_DISC_3: 0,
        M_DISC_4: 0,
        ShipToDesc: info.address,
        M_TP_PENJ: "FGS",
        Grade: item.grade,
        gudang: item.gudang_selected,
      };
      if (item.M_KD_CMPG !== undefined) payload.M_KD_CMPG = item.M_KD_CMPG;
      if (item.M_KET_CMPG !== undefined) payload.M_KET_CMPG = item.M_KET_CMPG;
      if (item.dealer_id !== undefined) payload.dealer_id = item.dealer_id;
      if (item.type === "I") {
        if (!includes(userInfo.role_name, "MHC Dealer")) {
          let cardcodes = [...userInfo.MI_cardcode];
          cardcodes = cardcodes.filter((item) => {
            return item.CardName.indexOf(stateEventType) > -1;
          });
          if (cardcodes[0]) {
            payload.cardcode = cardcodes[0].CardCode;
            payload.cardname = cardcodes[0].CardName;
            payload.mi_cardcode = cardcodes[0].U_M_BP_CODE_MI;
            payload.M_TP_PENJ = stateEventType;

            const reqMore = [
              getCustInfo(payload.mi_cardcode).then((res) => res.data),
            ];

            Promise.all(reqMore).then((resultsMore) => {
              const [_custinfo] = resultsMore;

              if (!isObjectEmpty(_custinfo)) {
                if (!isObjectEmpty(_custinfo["shipping-address"])) {
                  if (_custinfo["shipping-address"]["S"].length) {
                    let addr = _custinfo["shipping-address"]["S"];
                    //payload.ShipToCode = addr[0].Address;
                    //payload.ShipToDesc = `${addr[0].addr}, ${addr[0].namecity}`;
                  }
                }
              }

              setState({ ...state, ppn_selected: rate_ppn });
              const response = createSODetail(payload);
              response
                .then((res) => {
                  if (pageState == "create") {
                    navigate("/salesorder/edit/" + state.order_id);
                    setTimeout(() => {
                      setState({
                        ...state,
                        refresh: true /*, DefaultIndentShipToCode: payload.ShipToCode, DefaultIndentShipToDesc: payload.ShipToDesc*/,
                      });
                    }, 500);
                  } else {
                    setTimeout(() => {
                      setState({
                        ...state,
                        refresh: true /*, DefaultIndentShipToCode: payload.ShipToCode, DefaultIndentShipToDesc: payload.ShipToDesc*/,
                      });
                    }, 500);
                  }
                  $("#modal-product").modal("hide");
                })
                .catch(({ response: { data } }) => {
                  handlerFormError(data);
                })
                .finally((_) => {
                  stopProcessing();
                  setState({
                    ...state,
                    enable_add_product_detail: true,
                    DefaultIndentShipToCode: payload.ShipToCode,
                    DefaultIndentShipToDesc: payload.ShipToDesc,
                  });
                });
            });
          }
        } else {
          const response = createSODetail(payload);
          response
            .then((res) => {
              if (pageState == "create") {
                navigate("/salesorder/edit/" + state.order_id);
                setTimeout(() => {
                  setState({
                    ...state,
                    refresh: true /*, DefaultIndentShipToCode: payload.ShipToCode, DefaultIndentShipToDesc: payload.ShipToDesc*/,
                  });
                }, 500);
              } else {
                setTimeout(() => {
                  setState({
                    ...state,
                    refresh: true /*, DefaultIndentShipToCode: payload.ShipToCode, DefaultIndentShipToDesc: payload.ShipToDesc*/,
                  });
                }, 500);
              }
              $("#modal-product").modal("hide");
            })
            .catch(({ response: { data } }) => {
              handlerFormError(data);
            })
            .finally((_) => {
              stopProcessing();
              setState({
                ...state,
                enable_add_product_detail: true,
                DefaultIndentShipToCode: payload.ShipToCode,
                DefaultIndentShipToDesc: payload.ShipToDesc,
              });
            });
        }
      } else {
        setState({ ...state, ppn_selected: rate_ppn });
        const response = createSODetail(payload);
        response
          .then((res) => {
            if (pageState == "create") {
              navigate("/salesorder/edit/" + state.order_id);
              setTimeout(() => {
                setState({ ...state, refresh: true });
              }, 500);
            } else {
              setTimeout(() => {
                setState({ ...state, refresh: true });
              }, 500);
            }
            $("#modal-product").modal("hide");
          })
          .catch(({ response: { data } }) => {
            handlerFormError(data);
          })
          .finally((_) => {
            stopProcessing();
            setState({ ...state, enable_add_product_detail: true });
          });
      }
    }
  };

  const onNpwpChange = (e) => {
    let npwp = e.target.value;
    setInfo({ ...info, npwp: npwp });
  };

  //ke depannya kalau ada pengecekan terkait listPayment bisa dipindahkan ke sini
  const paymentValidation = (payment_detail) => {
    let message = "";
    let shouldBreak = false;
    if (!payment_detail.File) {
      message = "You need to upload payment proof!";
    }
    if (payment_detail[0].card_number === null) {
      message += (message !== "" ? "\n" : "") + "Card number is required!";
    }

    return message;
  };
  const onVerifyPayment = async (status) => {
    const res = await verifyPayment(id_so, status);
    if (res.status == 200) {
      Swal.fire({
        icon: "success",
        title: "Payment Verification Done!",
        text:
          status == "R"
            ? "Payment succesfully verified. Your purchase order is being processed"
            : "Payment succesfully rejected",
      }).then(() => setState({ ...state, refresh: true }));
    } else {
      Swal.fire({
        icon: "success",
        title: "Payment Verification failed!",
        text: "Please re-check your data or contact support!",
      });
    }
  };

  const onCancelPaymentLink = async () => {
    cancelPaymentLink(state.order_no)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Update payment done!",
          text: "Payment link canceled",
        }).then(() => {
          setState({ ...state, refresh: true });
          setHideSubmitPayment(false);
        });
      })
      .catch(({ response: { data } }) => {
        Swal.fire({
          icon: "error",
          title: "Update payment failed",
          text: data.message,
        });
      });
  };

  const onSendEmailNotifCustomerNonIPG = async () => {
    setState({ ...state, processingBtn: true });
    sendEmailNonIpg(id_so)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Email Notification Non IPG",
          text: "Email Notification already sent!",
        }).then(() => {
          setState({ ...state, processing: false });
        });
      })
      .catch(({ response: { data } }) => {
        setState({ ...state, processingBtn: false });
        Swal.fire({
          icon: "error",
          title: "Email Notification Non IPG failed",
          text: data.message,
        });
      });
  };

  const onSavePayment = () => {
    setHideSubmitPayment(true);
    let subtotal = 0;
    let isSave = false;
    if (listPayment.length == 0) {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Payment required..!",
      });
      setHideSubmitPayment(false);
      return;
    }
    // debugger;
    if (listPayment[0].nominal_payment != (Math.round(totalMZF) - deduction)) {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Paid amount is not the same as grand total!",
      });
      setHideSubmitPayment(false);
      return;
    }

    if (listPayment[0].payment_type == "IPG") {
      let payload = {
        ipg_notif_email: info.email,
        ipg_notif_wa: info.phone ? "+62" + info.phone : "",
      };
      createPaymentGateway(state.order_no, payload)
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            Swal.fire({
              icon: "success",
              title: "Save payment success",
              text: "Data has been saved!",
            }).then((r) => {
              setState({ ...state, refresh: true });
              setHideSubmitPayment(true);
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Save payment failed",
              text: "There's an unknown error while processing your payment",
            });
            setHideSubmitPayment(false);
          }
        })
        .catch(({ response: { data } }) => {
          if (data) {
            Swal.fire({
              icon: "error",
              title: "Save payment failed",
              text: data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Save payment failed",
              text: "There's an unknown error while processing your payment",
            });
          }
          setHideSubmitPayment(false);
        });
      return;
    }
    for (const element of listPayment) {
      subtotal += parseFloat(element.nominal_payment);
      if (element.isSave) {
        isSave = true;
      }
    }
    // if (Math.round(subtotal) > Math.round(info.grand_total)) {
    //   Swal.fire({
    //     icon: "error",
    //     timer: 1500,
    //     showConfirmButton: false,
    //     title: "Payment cannot be more than Grand Total!",
    //   });
    //   setState({ ...state, showbtnpayment: true });
    //   setHideSubmitPayment(false);
    //   return;
    // }

    // if (listPayment.length == 4) {
    //   if (Math.round(subtotal) < Math.round(info.grand_total)) {
    //     Swal.fire({
    //       icon: "error",
    //       timer: 1500,
    //       showConfirmButton: false,
    //       title: "Payment must be completed, only 4 lines available !",
    //     });
    //     setState({ ...state, showbtnpayment: true });
    //     setHideSubmitPayment(false);
    //     return;
    //   }
    // }

    // if (Math.round(subtotal) < Math.round(info.grand_total)) {
    //   Swal.fire({
    //     icon: "error",
    //     timer: 1500,
    //     showConfirmButton: false,
    //     title: "Paid amount is not the same as grand total!",
    //   });
    //   setState({ ...state, showbtnpayment: true });
    //   setHideSubmitPayment(false);
    //   return;
    // }

    const validation_results = paymentValidation(listPayment);

    if (validation_results) {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: validation_results,
      });
      setState({ ...state, loading: false });
      setHideSubmitPayment(false);
      return;
    }

    let line_payment = [...listPayment];
    const formData = new FormData();
    formData.append("File", listPayment.File);
    delete line_payment.File;
    delete line_payment.img_upload;
    let another_line_payment = [];
    for (const element of line_payment) {
      let new_line_payment = {};
      new_line_payment["Amount"] = element.nominal_payment;
      new_line_payment["TypePayment"] = element.payment_type;
      new_line_payment["Bank"] = element.bank;
      new_line_payment["line_payment"] = element.line_payment;
      new_line_payment["DocNumSO"] = state.order_no;
      new_line_payment["tr_salesorder_h_id"] = state.order_id;
      new_line_payment["created_date"] = moment().format("YYYY-MM-DD");
      new_line_payment["created_by"] = userInfo.user_id;
      new_line_payment["card_number"] = element.card_number;
      new_line_payment["ipg_notif_email"] = info.email;
      new_line_payment["ipg_notif_wa"] = info.phone ? "+62" + info.phone : "";
      another_line_payment.push(new_line_payment);
    }
    formData.append("line_payment", JSON.stringify(another_line_payment));
    //request.push(

    if (info.status_so === "Closed" && info.payment_verified === false) {
      updateSO(state.order_id, {
        Status: "Closed",
        action: "resend rejected SO payment",
      }).then((res) => {
        if (res.data.status == 200) {
          createPayment(formData)
            .then((res) => {
              if (res.status == 200 || res.status == 201) {
                Swal.fire({
                  icon: "success",
                  title: "Save payment success",
                  text: "Data has been saved!",
                }).then((r) => {
                  setState({ ...state, refresh: true });
                  setHideSubmitPayment(true);
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Save payment failed",
                  text: "There's an unknown error while processing your payment",
                });
                setHideSubmitPayment(false);
              }
            })
            .catch(({ response: { data } }) => {
              if (data) {
                handlerFormError(data);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Save payment failed",
                  text: "There's an unknown error while processing your payment",
                });
              }
              setHideSubmitPayment(false);
            });
        } else {
          Swal.fire({
            icon: "error",
            title: "Update SO Status Failed",
          });
          setHideSubmitPayment(false);
          return;
        }
      });
    } else {
      createPayment(formData)
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            Swal.fire({
              icon: "success",
              title: "Save payment success",
              text: "Data has been saved!",
            }).then((r) => {
              setState({ ...state, refresh: true });
            });
            setHideSubmitPayment(true);
          } else {
            Swal.fire({
              icon: "error",
              title: "Save payment failed",
              text: "There's an unknown error while processing your payment",
            });
            setHideSubmitPayment(false);
          }
        })
        .catch(({ response: { data } }) => {
          if (data) {
            handlerFormError(data);
          } else {
            Swal.fire({
              icon: "error",
              title: "Save payment failed",
              text: "There's an unknown error while processing your payment",
            });
          }
          setHideSubmitPayment(false);
        });
    }

    //);
    /*for(const element of listPayment){
            if(element.nominal_payment < 1){
                Swal.fire({
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                    title: "Amount must be greater than 0!"
                });
                return;
            }
            else if(element.isSave == false){
                const formData = new FormData();
                formData.append("tr_salesorder_h_id", state.order_id);
                formData.append("DocNumSO", state.order_no);
                formData.append("Bank", element.bank);
                formData.append("TypePayment", element.payment_type);
                formData.append("Amount", element.nominal_payment);
                formData.append("created_date", moment().format('YYYY-MM-DD'));
                formData.append("created_by", userInfo.user_id);
                if(listPayment.File){
                    formData.append("File", listPayment.File);
                }
                     
                request.push(
                    createPayment(formData)
                    .then(res => res.data)
                    .catch(({ response: { data } }) => {
                        handlerFormError(data);
                    })
                );
            }
            else{
                const formData = new FormData();
                formData.append("tr_salesorder_h_id", state.order_id);
                formData.append("DocNumSO", state.order_no);
                formData.append("Bank", element.bank);
                formData.append("TypePayment", element.payment_type);
                formData.append("Amount", element.nominal_payment);
                formData.append("Update_date", moment().format('YYYY-MM-DD'));
                formData.append("Update_by", userInfo.user_id);
                if(listPayment.File){
                    formData.append("File", listPayment.File);
                }
                request.push(
                    updatePayment(element.index, formData)
                    .then(res => res.data)
                    .catch(({ response: { data } }) => {
                            handlerFormError(data);
                        })
                );
            }
        }*/
    /*setTimeout(() => {
            Promise.all(request).then(results => {
                for (const key in results) {
                    if(results[key] != undefined){
                        count_save++;
                    }
                }
                if(count_save == listPayment.length){
                    Swal.fire({
                        icon: 'success',
                        title: 'Save payment success',
                        text: 'Data has been saved!'
                    }).then(r => { 
                        setState({...state, refresh: true});
                    })
                }
                stopProcessing();
                
            })
            .catch(function(err) {
                Swal.fire({
                    icon: 'error',
                    title: 'Save payment failed',
                    text: err
                });
                stopProcessing();
            });
           
        }, 2000);*/
  };

  const addPayment = () => {
    if (listPayment.length >= 4) {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Max 4 rows data..!",
      });
      return;
    }

    let subtotal = 0;
    for (const element of listPayment) {
      subtotal += parseFloat(element.nominal_payment);
    }
    let sisa = Math.round(/*info.grand_total*/ total) - Math.round(subtotal);
    if (sisa <= 0) {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Total must be greater than zero..!",
      });
      return;
    }
    listPayment.push({
      index: uuid(),
      bank: bank.length > 1 ? bank[0].value : "MANDIRI",
      payment_type: "IPG",
      nominal_payment: ParseDecimal(sisa),
      img_upload: "",
      File: null,
      isSave: false,
      line_payment: linePayment,
      card_number: null,
    });
    setState({
      ...state,
      listPayment,
      showbtnpayment: true,
      total_payment: /*subtotal + sisa*/ total,
    });
    let line = linePayment;
    line = line + 1;
    setLinePayment(line);
  };

  /*useEffect(() => {
        console.log(listPayment)
    }, [state])*/

  const onChangePhone = (e) => {
    setValue("Phone1", e.target.value.split(/\D/).join(""));
  };

  const Calculate = (details) => {
    let subtotal = 0;
    let subtotal2 = 0;
    let amount_ppn = 0;
    let amount_pph = 0;
    let amount_dpp = 0;
    let amount_disc = 0;
    for (const key in details) {
      let amount = details[key].qty * details[key].price;
      let amount2 =
        details[key].free == 1 ? 0 : details[key].qty * details[key].price;
      subtotal += amount;
      subtotal2 += amount2;
      amount_ppn += parseFloat(details[key].amount_ppn);
      amount_pph += parseFloat(details[key].amount_pph);
      amount_dpp += parseFloat(details[key].amount_dpp);
      amount_disc += parseFloat(details[key].amount_discount);
    }
    return {
      subtotal,
      subtotal2,
      amount_ppn,
      amount_pph,
      amount_dpp,
      amount_disc,
    };
  };

  const onEdit = (item) => () => {
    reset(item);
    setValue("form_province", item.county_code);

    setState({ ...state, customer: item });

    getProvince(item.county_code).then((res) => {
      const _prov = res.data.data.map((item) => {
        return {
          label: item.U_SOL_CITY_NAME,
          value: item.U_SOL_CITY_CODE,
        };
      });
      setTimeout(() => {
        setInfo({
          ...info,
          province: _prov,
          province_label: item.County,
          city_label: item.City,
        });
      }, 500);
      setTimeout(() => {
        setValue("form_city", item.city_code);
      }, 1000);
    });
    $("#modal-form").modal();
  };

  /*const getDataProduct = payload => {
        var promise = new Promise((resolve, reject) => {
            const result = {
                data: {
                    data: data_product,
                    total: 1
                }
            };
            resolve(result);
        });
        return promise;
    };*/

  const addProduct = () => {
    mTableP.current.reset();
    $('[name="inlineRadioOptions"]').prop("checked", false);
    setState({ ...state, showProduct: false });
    $("#modal-product").modal();
    document.querySelector("#modal-product-detail").style.display = "block";
    document.querySelector("#modal-product-preorder").style.display = "none";
  };
  const promo = (item) => {
    $('[name="radio"]').prop("checked", false);
    getPromo({
      ItemCode: item.itemno,
      BPLId: "BRANCH|" + userInfo.BPLId + "|" + userInfo.BPLName,
      OrderType: item.M_TP_PENJ,
    }).then((res) => {
      if (res.data.status == 500) {
        Swal.fire({
          icon: "error",
          title: res.data.message,
        });
      } else {
        setState({
          ...state,
          listPromo: res.data.data,
          listPromoSelected: item.id,
        });
      }
    });
    $("#modal-promo").modal();
  };

  const cancelpromokode = () => {
    setState({ ...state, loading: true });
    const response = cancelpromokodeSvc(state.order_id);
    response
      .then((res) => {
        if (res.status != 200) {
          Swal.fire({
            icon: "error",
            title: res.data.message,
          });
        }
      })
      .catch((error) => { })
      .finally((_) => {
        navigate("/salesorder/edit/" + state.order_id);
        setTimeout(() => {
          setState({ ...state, refresh: true, kupon_kode: "", loading: false });
        }, 500);
      });
  };
  const cancelpromo = (item) => {
    let paketid = item.paketid;
    setState({ ...state, loading: true });
    let filteredArray = detail;
    const index = filteredArray.findIndex((e) => e.id == item.id);
    if (index > -1) {
      filteredArray[index].paketid = "";
      filteredArray[index].paket_name = "";
    }
    let arr_item = [];
    let arr_free_item = [];
    for (const key in filteredArray) {
      if (filteredArray[key].free == 0) {
        arr_item.push({
          item_id: filteredArray[key].itemno,
          harga: filteredArray[key].price,
          paketid: filteredArray[key].paketid,
          kuantitas: filteredArray[key].qty,
          gudang: filteredArray[key].gudang,
          so_d_svc_id: filteredArray[key].id,
          diskon: filteredArray[key].disc_2,
          order_type: filteredArray[key].M_TP_PENJ,
        });
      } else {
        arr_free_item.push({
          paketid: filteredArray[key].paketid,
          item_id: filteredArray[key].itemno,
          so_d_svc_id: filteredArray[key].id,
        });
      }
    }

    let payload = {
      order_id: state.order_no,
      dealer_id: "BRANCH|" + userInfo.BPLId + "|" + userInfo.BPLName,
      paketid: paketid,
      so_h_svc_id: state.order_id,
      kupon_kode: "",
      item: arr_item,
      free_item: arr_free_item,
    };

    const response = applyCampaign(payload);
    response
      .then((res) => {
        if (res.data.data == undefined) {
          Swal.fire({
            icon: "error",
            title: res.data.message,
          });
        } else {
          setTimeout(() => {
            setState({ ...state, refresh: true });
          }, 500);
        }
      })
      .catch((error) => { })
      .finally((_) => setState({ ...state, loading: false }));
  };

  const applyPromo = () => {
    if (!locked) {
      setState({ ...state, listPromo: [] });
      $("#modal-promo-header").modal();
    }
  };
  const showPPH = () => {
    $("#modal-pph").modal();
  };
  const showDeduction = () => {
    $("#modal-deduction").modal();
  };
  const minus = () => {
    if (state.opsiProduct.type == "") {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Please choose type stok..!",
      });
      return;
    }
    let min = state.opsiProduct.qty - 1;
    if (min < 1) min = 0;
    const _opsiProduct = { ...state.opsiProduct, qty: min };
    setState({ ...state, opsiProduct: _opsiProduct });
  };
  const plus = () => {
    if (state.opsiProduct.type == "") {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Please choose type stok..!",
      });
      return;
    }
    let pls = state.opsiProduct.qty + 1;
    if (pls > state.opsiProduct.qty_selected) {
      pls = state.opsiProduct.qty_selected;
    }
    const _opsiProduct = { ...state.opsiProduct, qty: pls };
    setState({ ...state, opsiProduct: _opsiProduct });
  };

  const onChangeQty = (e) => {
    if (state.opsiProduct.type == "") {
      Swal.fire({
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
        title: "Please choose type stok..!",
      });
      return;
    }

    let pls = e.target.value;
    if (pls > state.opsiProduct.qty_selected) {
      pls = state.opsiProduct.qty_selected;
    }
    if (pls < 1) pls = 1;
    const _opsiProduct = { ...state.opsiProduct, qty: pls };
    setState({ ...state, opsiProduct: _opsiProduct });
  };
  const onRemovePayment = (row) => {
    let hpusArray = [];
    let temp_array = {};
    temp_array.img_upload = listPayment.img_upload
      ? listPayment.img_upload
      : "";
    temp_array.File = listPayment.File ? listPayment.File : "";
    if (row.isSave) {
      deletePayment(row.index, (res) => {
        hpusArray = listPayment.filter((item) => item.index !== row.index);
        let subtotal = 0;
        for (const key in hpusArray) {
          subtotal += parseFloat(hpusArray[key].nominal_payment);
        }
        let sisa = info.grand_total - subtotal;
        hpusArray.img_upload = temp_array.img_upload;
        hpusArray.File = temp_array.File;
        setState({
          ...state,
          listPayment: hpusArray,
          showbtnpayment: sisa <= 0 ? false : true,
          total_payment: subtotal,
        });
      });
    } else {
      hpusArray = listPayment.filter((item) => item.index !== row.index);
      let line = 1;
      let subtotal = 0;
      for (const key in hpusArray) {
        subtotal += parseFloat(hpusArray[key].nominal_payment);
        hpusArray[key]["line_payment"] = line;
        line++;
      }
      let sisa = info.grand_total - subtotal;
      hpusArray.img_upload = temp_array.img_upload;
      hpusArray.File = temp_array.File;

      line = hpusArray.length + 1;
      setLinePayment(line);

      setState({
        ...state,
        listPayment: hpusArray,
        showbtnpayment: sisa <= 0 ? false : true,
        total_payment: subtotal,
      });
    }
  };
  const cekHitungan = (items, _deduction, _total, _pph_rate) => {
    for (const index in items) {
      let subtotal = items[index].price * items[index].qty;
      let disc_deduction = parseFloat((_deduction / _total) * 100);
      let disc_total = subtotal * (parseFloat(disc_deduction) / 100);
      let dpp = parseFloat(
        items[index].ppn == 0
          ? 0
          : (subtotal - disc_total) / (1 + items[index].ppn / 100)
      ).toFixed(3);
      let am_ppn = parseFloat(dpp * (items[index].ppn / 100)).toFixed(2);

      items[index].amount_ppn = am_ppn;
      items[index].amount_dpp = dpp;
      items[index].disc_deduction = disc_deduction;
      items[index].disc_total = disc_total;
      items[index].amount_pph =
        items[index].pph == "y" ? dpp * (_pph_rate / 100) : 0;
    }
    return items;
  };
  const onRemoveProduct = (row) => {
    if (row.paketid != null && row.paketid != "") {
      deleteSODetail(
        row.id,
        (res) => {
          if (res.status == 200 || res.status == 201) {
            if (deduction_amount > 0) {
              updateSO(state.order_id, { DiscSum: 0, deduction_remark: "" })
                .then(() => {
                  if (res.data.status == 200) {
                    Swal.fire({
                      icon: "success",
                      title: "Delete data success",
                      text: "Data has been deleted!",
                    }).then((res) => {
                      if (pageState == "create") {
                        navigate("/salesorder/edit/" + state.order_id);
                        setTimeout(() => {
                          setState({ ...state, refresh: true });
                        }, 500);
                      } else {
                        setTimeout(() => {
                          setState({ ...state, refresh: true });
                        }, 500);
                      }
                      $("#modal-product").modal("hide");
                    });
                  } else {
                    Swal.fire({
                      icon: "success",
                      title: "Delete data success, but delete deduction failed",
                    });

                    return;
                  }
                })
                .catch((err) => {
                  Swal.fire({
                    icon: "success",
                    title: "Delete data success, but delete deduction failed",
                  });
                  return;
                });
            } else {
              Swal.fire({
                icon: "success",
                title: "Delete data success",
                text: "Data has been deleted!",
              }).then((res) => {
                DMCalculation(row.paketid, row.id, "D");
                $("#modal-product").modal("hide");
              });
            }
          }
        },
        ({ response: { data } }) => {
          Swal.fire({
            icon: "error",
            title: "Delete data fail",
            text: data.message,
          });
        }
      );
    } else {
      deleteSODetail(
        row.id,
        (res) => {
          if (res.status == 200 || res.status == 201) {
            if (deduction_amount > 0) {
              updateSO(state.order_id, { DiscSum: 0, deduction_remark: "" })
                .then((res) => {
                  if (res.data.status == 200) {
                    Swal.fire({
                      icon: "success",
                      title: "Delete data success",
                      text: "Data has been deleted!",
                    }).then((res) => {
                      if (pageState == "create") {
                        navigate("/salesorder/edit/" + state.order_id);
                        setTimeout(() => {
                          setState({ ...state, refresh: true });
                        }, 500);
                      } else {
                        setTimeout(() => {
                          setState({ ...state, refresh: true });
                        }, 500);
                      }
                      $("#modal-product").modal("hide");
                    });
                  } else {
                    Swal.fire({
                      icon: "success",
                      title: "Delete data success, but delete deduction failed",
                    });

                    return;
                  }
                })
                .catch((err) => {
                  Swal.fire({
                    icon: "success",
                    title: "Delete data success, but delete deduction failed",
                  });
                  return;
                });
            } else {
              Swal.fire({
                icon: "success",
                title: "Delete data success",
                text: "Data has been deleted!",
              }).then((res) => {
                if (pageState == "create") {
                  navigate("/salesorder/edit/" + state.order_id);
                  setTimeout(() => {
                    setState({ ...state, refresh: true });
                  }, 500);
                } else {
                  setTimeout(() => {
                    setState({ ...state, refresh: true });
                  }, 500);
                }
                $("#modal-product").modal("hide");
              });
            }
          }
        },
        ({ response: { data } }) => {
          Swal.fire({
            icon: "error",
            title: "Delete data fail",
            text: data.message,
          });
        }
      );
    }
  };
  const onRadioChange = (e, gd, qty) => {
    const _opsiProduct = {
      ...state.opsiProduct,
      type: e.target.value,
      gudang_selected: gd,
      qty_selected: qty,
      qty: 1,
    };
    if (e.target.value === "I") {
      const indentIndex = indent_warehouses.findIndex(w => w.WhsCode === gd);
      if (indentIndex >= 0) {
        _opsiProduct.gudang_selected = indent_warehouses[indentIndex].WhsCode;
        _opsiProduct.qty_selected = indent_warehouses[indentIndex].OnHand;
        _opsiProduct.qty = indent_warehouses[indentIndex].OnHand > 0 ? 1 : 0;
      }
    }

    setState({ ...state, opsiProduct: _opsiProduct });
  };

  const hitungTotalDisc = (items) => {
    let total_disk = 0;
    for (const key in items) {
      let _subtotal = items[key].price * items[key].qty;
      let _net_disc = items[key].net_disc > 0 ? items[key].net_disc / 100 : 0;
      let _net_disc_amt = _subtotal - _subtotal * _net_disc;
      let _campaign_disc = parseFloat(items[key].disc_2) / _net_disc_amt;
      let _prcntdisc = _net_disc + (1 - _net_disc) * _campaign_disc;

      total_disk += _prcntdisc * _subtotal;
    }
    return total_disk;
  };
  const onChangePPN = (e, row) => {
    let vat = parseFloat(e.target.value);
    const index_ppn = listppn.findIndex((i) => parseFloat(i.Rate) == vat);
    let Code = "";
    if (index_ppn > -1) {
      Code = listppn[index_ppn].Code;
    }
    let payload = {
      VatPrcnt: e.target.value,
      VatGroup: Code,
    };
    const response = updateSODetail(row.id, payload);
    response.then((res) => {
      setState({ ...state, refresh: true });
    });
  };
  const onChangePPH = (e, row) => {
    const selected_row = row.urut;

    let detail_array = [...detail];
    const detail_index = findIndex(detail_array, { urut: selected_row });
    detail_array[detail_index].pph = e.target.value;
    setInfo({ ...info, detail: detail_array });

    let payload = {
      WtLiable: e.target.value == "y" ? true : false,
    };
    //const response = updateSODetail(row.id,payload)
    updateSODetail(row.id, payload);
    /*response.then(res => {
            //setState({...state, refresh: true});
            setState({...state});
        })*/
  };

  const customerInfoChecker = (_custinfo) => {
    if (!_custinfo.npwp) return false;
    else if (_custinfo.npwp.length <= 0) return false;
    else if (!_custinfo["shipping-address"]) return false;
    else if (!_custinfo["shipping-address"]["S"]) return false;
    else if (_custinfo["shipping-address"]["S"].length <= 0) return false;
    else return true;
  };
  const onChangeOrderType = (e, row) => {
    let payload = {
      M_TP_PENJ: e.target.value,
    };
    if (row.type == "I") {
      let cardcodes = [...userInfo.MI_cardcode];
      cardcodes = cardcodes.filter((item) => {
        return item.CardName.indexOf(e.target.value) > -1;
      });
      if (cardcodes[0]) {
        if (!cardcodes[0].U_M_BP_CODE_MI) {
          payload.M_TP_PENJ = "FGS";
          let codes = [...userInfo.MI_cardcode];
          codes = codes.filter((item) => {
            return item.CardName.indexOf("FGS") > -1;
          });
          payload.cardcode = codes[0].CardCode;
          payload.cardname = codes[0].CardName;
          payload.mi_cardcode = codes[0].U_M_BP_CODE_MI;
          row.ShipToCode =
            /*payload.ShipToCode =*/ state.DefaultIndentShipToCode;
          row.ShipToDesc =
            /*payload.ShipToDesc =*/ state.DefaultIndentShipToDesc;
          const response = updateSODetail(row.id, payload);
          response.then((res) => {
            setState({ ...state, refresh: true });
          });
          Swal.fire({
            icon: "error",
            title: "Get Data Failed",
            text: "Customer data is not found for that order type. Please choose another type!",
          });
          return;
        }
        const reqMore = [
          getCustInfo(cardcodes[0].U_M_BP_CODE_MI).then((res) => res.data),
        ];

        Promise.all(reqMore)
          .then((resultsMore) => {
            const [_custinfo] = resultsMore;
            if (isObjectEmpty(_custinfo))
              throw "Error in getting customer data";
            if (!customerInfoChecker(_custinfo))
              throw "Error in getting customer data";
            payload.cardcode = cardcodes[0].CardCode;
            payload.cardname = cardcodes[0].CardName;
            payload.mi_cardcode = cardcodes[0].U_M_BP_CODE_MI;
            //if(!isObjectEmpty(_custinfo)){
            if (!isObjectEmpty(_custinfo["shipping-address"])) {
              if (_custinfo["shipping-address"]["S"].length) {
                let addr = _custinfo["shipping-address"]["S"];
                row.ShipToCode = /*payload.ShipToCode =*/ addr[0].Address;
                row.ShipToDesc = /* payload.ShipToDesc =*/ `${addr[0].addr}, ${addr[0].namecity}`;
              }
            }
            //}
            const response = updateSODetail(row.id, payload);
            response.then((res) => {
              setState({ ...state, refresh: true });
            });
          })
          .catch(() => {
            payload.M_TP_PENJ = "FGS";
            let codes = [...userInfo.MI_cardcode];
            codes = codes.filter((item) => {
              return item.CardName.indexOf("FGS") > -1;
            });
            payload.cardcode = codes[0].CardCode;
            payload.cardname = codes[0].CardName;
            payload.mi_cardcode = codes[0].U_M_BP_CODE_MI;
            row.ShipToCode =
              /*payload.ShipToCode =*/ state.DefaultIndentShipToCode;
            row.ShipToDesc =
              /*payload.ShipToDesc =*/ state.DefaultIndentShipToDesc;
            const response = updateSODetail(row.id, payload);
            response.then((res) => {
              setState({ ...state, refresh: true });
            });
            Swal.fire({
              icon: "error",
              title: "Get Data Failed",
              text: "Customer data is not found for that order type. Please choose another type!",
            });
          });
      } else {
        payload.M_TP_PENJ = "FGS";
        let codes = [...userInfo.MI_cardcode];
        codes = codes.filter((item) => {
          return item.CardName.indexOf("FGS") > -1;
        });
        payload.cardcode = codes[0].CardCode;
        payload.cardname = codes[0].CardName;
        payload.mi_cardcode = codes[0].U_M_BP_CODE_MI;
        const response = updateSODetail(row.id, payload);
        response.then((res) => {
          setState({ ...state, refresh: true });
        });
        Swal.fire({
          icon: "error",
          title: "Get Data Failed",
          text: "Customer data is not found for that order type. Please choose another type!",
        });
      }
    }
  };
  const onAddAdditionalAddress = (row, values) => {
    modalAdditionalRef.current[row].closeThisModal();
    //const values = modalAdditionalRef.current.getCustomerFormValues();

    const index = detail.findIndex((e) => e.id == row);
    if (index > -1) {
      detail[index] = Object.assign({}, detail[index], values);
    }
    const response = updateSODetail(row, values);
    response.then((res) => {
      if (res.status == 200) setInfo({ ...info, detail });
      else {
        Swal.fire({
          icon: "error",
          title: "Internal Server Error. Please Try Again",
        });
      }
    });
  };
  const onDeleteAdditionalAddress = (e, row) => {
    const values = {
      additional_address: "",
      additional_receiver: "",
      additional_city: "",
      additional_county: "",
      additional_phone: "",
    };
    const index = detail.findIndex((e) => e.id == row.id);
    if (index > -1) {
      detail[index] = Object.assign({}, detail[index], values);
    }
    const response = updateSODetail(row.id, values);
    response.then((res) => {
      if (res.status == 200) setInfo({ ...info, detail });
      else {
        Swal.fire({
          icon: "error",
          title: "Internal Server Error. Please Try Again",
        });
      }
    });
  };
  const onChangeDelivery = (e, row) => {
    const index = detail.findIndex((e) => e.id == row.id);
    if (index > -1) {
      detail[index].delivery = e.target.checked;
    }
    let payload = {
      Delivery: e.target.checked,
    };
    const response = updateDelivery(row.id, payload);
    response.then((res) => {
      setInfo({ ...info, detail });
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });
  const onUse = (value) => {
    DMCalculation(
      value.paketid,
      state.listPromoSelected,
      "I",
      value.keterangan_paket
    );
    $("#modal-promo").modal("hide");
  };

  const DMCalculation = (
    paketid,
    id,
    action,
    paket_name = "",
    promo_code = ""
  ) => {
    setState({ ...state, loading: true });
    let filteredArray = [];
    let index = -1;
    if (action == "D") {
      filteredArray = detail.filter((item) => item.id !== id);
    } else {
      filteredArray = detail;
      index = filteredArray.findIndex((e) => e.id == id);
      if (index > -1) {
        filteredArray[index].paketid = paketid;
        filteredArray[index].paket_name = paket_name;
      }
    }
    let arr_item = [];
    let arr_free_item = [];
    for (const key in filteredArray) {
      if (filteredArray[key].free == 0) {
        arr_item.push({
          item_id: filteredArray[key].itemno,
          harga: filteredArray[key].net_disc_amt,
          paketid: filteredArray[key].paketid,
          kuantitas: filteredArray[key].qty,
          gudang: filteredArray[key].gudang,
          so_d_svc_id: filteredArray[key].id,
          diskon: filteredArray[key].disc_2,
          order_type: filteredArray[key].M_TP_PENJ,
        });
      } else {
        arr_free_item.push({
          paketid: filteredArray[key].paketid,
          item_id: filteredArray[key].itemno,
          so_d_svc_id: filteredArray[key].id,
        });
      }
    }
    let payload = {
      order_id: state.order_no,
      dealer_id: "BRANCH|" + userInfo.BPLId + "|" + userInfo.BPLName,
      paketid: paketid,
      so_h_svc_id: state.order_id,
      kupon_kode: promo_code,
      item: arr_item,
      free_item: arr_free_item,
    };

    const response = applyCampaign(payload);
    response
      .then((res) => {
        if (res.data.data == undefined) {
          Swal.fire({
            icon: "error",
            title: res.data.message,
          });
        } else {
          if (pageState == "create") {
            navigate("/salesorder/edit/" + state.order_id);
            setTimeout(() => {
              setState({
                ...state,
                refresh: true,
                kupon_kode: promo_code,
                loading: false,
              });
            }, 500);
          } else {
            setTimeout(() => {
              setState({
                ...state,
                refresh: true,
                kupon_kode: promo_code,
                loading: false,
              });
            }, 500);
          }
        }
      })
      .catch((error) => {
        const { response } = error;
        let message =
          "An unknown error while processing your request. Please contact support!";
        if (response.status == 400) {
          message = response.data.message;
          if (index > -1) {
            filteredArray[index].paketid = "";
            filteredArray[index].paket_name = "";
          }
        }
        Swal.fire({
          icon: "error",
          title: "Promo error",
          text: message,
        });
        //filteredArray[index].paketid = "";
        setState({ ...state, loading: false, detail: filteredArray });
      })
      .finally((_) => stopProcessing());
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };
  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const stopProcessingCustomerNoTimeOut = () => {
    setState({ ...state, processing: false, customer_saving: false });
  };

  const onClearDeduction = () => {
    setState({ ...state, deduction_amount: 0, deduction_comment: "" });
  };

  const onChangeTypeDeduction = (e) => {
    setState({ ...state, deduction_type: e.target.value, deduction_amount: 0 });
  };

  const onChangeDeductionAmount = (value, name) => {
    let val_amount = value == undefined ? 0 : value;
    if (value > 100 && deduction_type == "Percent") {
      val_amount = 100;
    }
    if (value > info.total - total_discount) {
      val_amount = info.total - total_discount;
    }
    setState({ ...state, deduction_amount: val_amount });
  };

  const submitDeduction = () => (event) => {
    event.preventDefault();
    const data = {
      type: deduction_type,
      amount:
        deduction_amount && deduction_amount > 0
          ? deduction_amount.toString().replace(/\./g, "")
          : 0,
      comment: state.deduction_comment,
    };
    if (data.type == "Percent") {
      data.amount = (info.total - total_discount) * (data.amount / 100);
    }
    setState({ ...state, processing: false });
    updateSO(
      state.order_id,
      {
        DiscSum: data.amount,
        deduction_remark: data.comment,
        sales_remark: info.sales_remark,
      },
      (res) => {
        $("#modal-deduction").modal("hide");
        setTimeout(() => {
          setState({ ...state, refresh: true });
        }, 500);
      },
      ({ response }) => {
        const { message } = response;
        Swal.fire({
          icon: "error",
          title: "Additional Deduction Error",
          text: message,
        });
      }
    ).finally(() => {
      setState({ ...state, processing: false });
    });
  };

  const onRowClickPPH = (item) => {
    let payload = {
      id_so: state.order_id,
      WTCode: item.WTCode,
      WTName: item.WTName,
      Rate: parseFloat(item.Rate),
    };
    const response = createTax(payload);
    response.then((res) => {
      $("#modal-pph").modal("hide");
      setTimeout(() => {
        if (res.status == 200 || res.status == 201)
          setInfo({ ...info, pph_rate: payload.Rate });
        setState({ ...state, refresh: true });
      }, 500);
    });
  };

  /*
   * Purpose: Menghilangkan awalan 0 atau 62 pada nomor telepon
   */
  const prunePhoneNumber = (phone_number) => {
    if (phone_number[0] == "0") return phone_number.slice(1);
    else if (phone_number[0] == "6" && phone_number[1] == "2")
      return phone_number.slice(2);
    else return phone_number;
  };

  const startProcessingCustomerNoTimeOut = () => {
    setState({ ...state, processing: true, customer_saving: true });
  };

  const onSubmit = (data) => {
    startProcessingCustomerNoTimeOut();
    data.Phone1 = prunePhoneNumber(data.Phone1);
    setInfo({
      ...info,
      kode_customer: data.CardCode,
      nama_customer: data.CardName,
      phone: data.Phone1,
      email: data.EmailAddress,
      address: data.Address,
    });
    if (state.customer.cardid !== undefined) {
      let data_update = {
        CardName: data.CardName,
        Phone1: data.Phone1,
        Address: data.Address,
        EmailAddress: data.EmailAddress,
        Series: info.series_cust,
        action: "update",
      };
      let data_address = {
        Address2: data.Address.substring(0, 50),
        Address3: data.Address.substring(50, 100),
        City: info.city_label,
        County: info.province_label,
        Country: "ID",
        AdresType: "S",
      };

      const response = updateCustomer(data.CardCode, data_update);
      response
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            let address_code =
              !data.address_code || data.address_code == "null"
                ? "Ship To"
                : data.address_code;
            const response_address = updateAddressCustomer(
              data.CardCode,
              address_code,
              data_address
            );
            response_address.then((res_address) => {
              const response_so_cek_draft = cekDraft(data.CardCode, {
                CardName: data.CardName,
              });
              response_so_cek_draft.then((res_cek_so) => {
                if (res_cek_so.data) {
                  const response_so_update = updateSO(res_cek_so.data.id, {
                    CardName: data.CardName,
                    shipping_address: data.Address,
                    shipping_city: info.city_label,
                    shipping_county: info.province_label,
                    shipping_name: data.CardName,
                  });
                  response_so_update.then((res_so) => {
                    Swal.fire({
                      icon: "success",
                      title: "Save data success",
                      text: "Data has been saved!",
                    }).then((r) => {
                      mTableC.current.refresh();
                      onReset();
                      $("#modal-form").modal("hide");
                      $("#modal-detail").modal("hide");
                      navigate("/salesorder/edit/" + res_cek_so.data.id);

                      setState({
                        ...state,
                        province: data.form_province,
                        city: data.form_city,
                        customer: {},
                        processing: false,
                        customer_saving: false,
                        order_id: res_cek_so.data.id,
                        order_no: res_cek_so.data.DocNumSO,
                        refresh: true,
                      });
                    });
                  });
                } else {
                  let payload_so = {
                    Series: includes(userInfo.role_name, "MHC Dealer")
                      ? 0
                      : info.series,
                    CardCode: data.CardCode,
                    CardName: data.CardName,
                    EmailAddress: data.EmailAddress,
                    Status: "Open",
                    ShipToCode: res_address.data.data.BPAddresses
                      ? res_address.data.data.BPAddresses[0]['"Address"']
                      : "",
                    BPLId: userInfo.BPLId,
                    BPLName: userInfo.BPLName,
                    shipping_name: data.CardName,
                    shipping_address: data.Address,
                    shipping_city: info.city_label,
                    shipping_county: info.province_label,
                    shipping_phone: data.Phone1,
                    shipping_mobilephone: data.Phone1,
                  };

                  if (payload_so.Series == "") {
                    Swal.fire({
                      icon: "error",
                      title: "Please select series first !!, series is empty",
                    });
                    return;
                  }

                  if (!includes(userInfo.role_name, "MHC Dealer")) {
                    payload_so["mi_cardcode"] =
                      userInfo.MI_cardcode[0].U_M_BP_CODE_MI;
                    payload_so["mhc_cardcode"] =
                      userInfo.MI_cardcode[0].CardCode;
                    payload_so["mhc_cardname"] =
                      userInfo.MI_cardcode[0].CardName;
                  }

                  createSOHeader(payload_so).then((res_header) => {
                    if (res.status == 200 || res.status == 201) {
                      Swal.fire({
                        icon: "success",
                        title: "Save data success",
                        text: "Data has been saved!",
                      }).then((r) => {
                        mTableC.current.refresh();
                        onReset();
                        $("#modal-form").modal("hide");
                        $("#modal-detail").modal("hide");
                        navigate("/salesorder/edit/" + res_header.data.id);
                        /*setTimeout(() => {
                                                setState({...state, refresh: true});
                                            }, 500);*/
                        setState({
                          ...state,
                          order_id: res_header.data.id,
                          order_no: res_header.data.DocNumSO,
                          refresh: true,
                        });
                      });
                    } else {
                      Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Sales order creation failed. Please try again. Sorry for the inconvenience",
                      }).then((r) => {
                        navigate("/dashboard");
                        /*setTimeout(() => {
                                                setState({...state, refresh: true});
                                            }, 500);*/
                        //setState({...state, order_id: res_header.data.id, order_no: res_header.data.DocNumSO, refresh:true})
                      });
                    }
                  });
                }
              });
            });
          }
        })
        .catch(({ response: { data } }) => {
          handlerFormError(data);
        })
        .finally((_) => stopProcessingCustomerNoTimeOut());
    } else {
      let data_address = {
        Address2: data.Address.substring(0, 50),
        Address3: data.Address.substring(50, 100),
        City: info.city_label,
        County: info.province_label,
        Country: "ID",
        AdresType: "S",
      };

      if (includes(userInfo.role_name, "MHC Dealer")) {
        data.GroupCode = null;
      }
      const response = createCustomer(data);
      response
        .then((res) => {
          if (res.status == 200 || res.status == 201 || res.status == 400) {
            const response_address = createAddress(
              data_address,
              res.data.data.CardCode
            );
            response_address.then((res_address) => {
              //setState({ ...state,});
              let payload_so = {
                Series: includes(userInfo.role_name, "MHC Dealer")
                  ? 0
                  : info.series,
                CardCode: res.data?.data?.CardCode,
                CardName: data.CardName,
                EmailAddress: data.EmailAddress,
                Status: "Open",
                ShipToCode: res_address.data.data.BPAddresses[0]['"Address"'],
                BPLId: userInfo.BPLId,
                BPLName: userInfo.BPLName,
                shipping_name: data.CardName,
                shipping_address: data.Address,
                shipping_city: info.city_label,
                shipping_county: info.province_label,
                shipping_phone: data.Phone1,
                shipping_mobilephone: data.Phone1,
                DocDueDate: info.delivery_date || moment().format("YYYY-MM-DD"),
              };

              if (payload_so.Series == "") {
                Swal.fire({
                  icon: "error",
                  title: "Please select series first !!, series is empty",
                });
                return;
              }

              if (!includes(userInfo.role_name, "MHC Dealer")) {
                payload_so["mi_cardcode"] =
                  userInfo.MI_cardcode[0].U_M_BP_CODE_MI;
                payload_so["mhc_cardcode"] = userInfo.MI_cardcode[0].CardCode;
                payload_so["mhc_cardname"] = userInfo.MI_cardcode[0].CardName;
              }

              createSOHeader(payload_so).then((res_header) => {
                let docnum_so =
                  res_header?.DocNumSO || res_header?.data?.DocNumSO;
                let order_id = res_header?.id || res_header?.data?.id || "";
                mTableC.current.refresh();
                onReset();
                $("#modal-form").modal("hide");
                $("#modal-detail").modal("hide");
                //setState({...state, order_id, order_no: docnum_so, province: data.form_province, city: data.form_city, customer: {},  customer_saving:false, processing: false})

                navigate("/salesorder/edit/" + order_id);
                navigate(0);

                Swal.fire({
                  icon: "success",
                  title: "Save data success",
                  text: "Data has been saved!",
                });
              });
            });
          } else if (res.status == 422) {
            const { message } = res.data;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
            });
          }
        })
        .catch((err) => {
          if (err?.response?.data?.status == 422) {
            if (err.response.data.errors) {
              let message = "";
              Object.keys(err.response.data.errors).forEach((key) => {
                message += `${key}: ${err.response.data.errors[key][0]}\n`;
              });

              Swal.fire({
                icon: "error",
                title: "Error",
                text: message,
              });
              stopProcessingCustomerNoTimeOut();
              return;
            }
          }
          //console.log(response);
          handlerFormError(err);
          stopProcessingCustomerNoTimeOut();
        });
    }
  };

  const onResubmitPO = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-modena",
        cancelButton: "btn btn-readonly mr-3",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Confirmation",
        text: "Are you sure submit this order ?",
        confirmButtonColor: "#3085d6",
        showCancelButton: true,
        confirmButtonText: "Yes",
        reverseButtons: true,
      })
      .then(({ isConfirmed }) => {
        if (isConfirmed) {
          setState({ ...state, loading: true });
          submitPO(
            state.order_id,
            {},
            (res) => {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Submit PO success ",
              }).then((res) => {
                setState({ ...state, refresh: true });
              });
            },
            ({ response }) => {
              const { message } = response;
              Swal.fire({
                icon: "error",
                title: "Submit PO Error",
                text: message,
              });
            }
          ).finally(() => {
            setState({ ...state, loading: false });
          });
        }
      });
  };

  const submitSO = () => {
    if (info.delivery_date == "Invalid date") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please put in delivery date",
      });
      return;
    }

    //check empty npwp
    // if (!info.npwp || info.npwp.trim() === "") {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Error",
    //     text: "Please provide NPWP",
    //   });
    //   return;
    // }

    const payload = {
      Series: info.series,
      CardCode: info.kode_customer,
      CardName: info.nama_customer,
      DocType: "I",
      Currency: "IDR",
      // DiscSum: info.deduction,
      BPLId: userInfo.BPLId,
      BPLName: userInfo.BPLName,
      // M_TP_PENJ: state.order_type,
      DocDueDate: info.delivery_date || moment().format("YYYY-MM-DD"),
      sales_remark: info.sales_remark,
      npwp: info.npwp,
    };

    if (includes(userInfo.role_name, "MHC Dealer")) {
      payload.Series = 0;
    }
    if (
      (info.status_so == "Open" || info.status_so == "Reject") &&
      deduction > 0
    ) {
      payload["Status"] = "Pending";
    } else if (
      (info.status_so == "Open" || info.status_so == "Reject") &&
      info.kode_customer.substring(0, 2) != "MR" &&
      deduction == 0
    ) {
      payload["Status"] = "Open";
      payload["act"] = "create";
    } else if (
      (info.status_so == "Open" || info.status_so == "Reject") &&
      info.kode_customer.substring(0, 2) == "MR" &&
      deduction == 0
    ) {
      payload["Status"] = "Sync";
      if (includes(userInfo.role_name, "MHC Dealer")) {
        payload["Status"] = "Open";
      }
      payload["act"] = "create";
    }

    payload.hitungan_frontend = {
      DocTotal: Math.round(
        /*info.total_before_discount_with_free-total_discount*/ totalMZF -
        deduction
      ),
      Pph: Math.round(ParseDecimal(info.total_pph)),
      DiscPrcnt:
        deduction /
        /*info.total_before_discount_with_free-total_discount*/ totalMZF,
      items: detail,
    };

    if (validate(payload)) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-modena",
          cancelButton: "btn btn-readonly mr-3",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Confirmation",
          text: "Are you sure submit this order ?",
          confirmButtonColor: "#3085d6",
          showCancelButton: true,
          confirmButtonText: "Yes",
          reverseButtons: true,
        })
        .then(({ isConfirmed }) => {
          if (isConfirmed) {
            setState({ ...state, loading: true });
            updateSO(
              state.order_id,
              payload,
              (res) => {
                const { data } = res.data;
                const base_url = REACT_APP_BASE_URL;
                if (info.deduction) {
                  const { DocNumSO } = data[0];
                  let payload = {
                    isHtml: true,
                    grand_total: NumberFormat(
                      Math.round(ParseDecimal(info.grand_total))
                    ),
                    total_before_discount: NumberFormat(
                      info.total_before_discount_with_free
                    ),
                    campaign_discount: info.total_discount,
                    deduction_amount: NumberFormat(
                      Math.round(ParseDecimal(deduction))
                    ),
                    id_so: DocNumSO,
                    deduction_remark: state.deduction_comment,
                    customer_name: info.nama_customer,
                    customer_address: info.address,
                    link_approval: `${base_url}salesorderapproval/view/${state.order_id}`,
                    link_detail: `${base_url}estatement/salesorder/${DocNumSO}`,
                  };
                  //console.log(payload);
                  sendDeductionNotification(payload);
                }
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: "Update sales order success ",
                }).then((res) => {
                  setState({ ...state, refresh: true });
                });
              },
              ({ response: { data } }) => {
                //handlerFormError(data);
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: data.message,
                }).then((res) => {
                  setState({ ...state, refresh: true });
                });
              }
            ).finally(() => {
              setState({ ...state, loading: false });
            });
          }
        });
    }
  };

  const rehitSAP = () => {
    const payload = {
      Series: info.series,
      CardCode: info.kode_customer,
      CardName: info.nama_customer,
      DocType: "I",
      Currency: "IDR",
      // DiscSum: info.deduction,
      BPLId: userInfo.BPLId,
      BPLName: userInfo.BPLName,
      // M_TP_PENJ: state.order_type,
      DocDueDate: info.delivery_date || moment().format("YYYY-MM-DD"),
      sales_remark: info.sales_remark,
      Status: "Open",
      act: "create",
    };

    if (includes(userInfo.role_name, "MHC Dealer")) {
      payload.Series = 0;
    }

    payload.hitungan_frontend = {
      DocTotal: Math.round(
        /*info.total_before_discount_with_free-total_discount*/ totalMZF -
        deduction
      ),
      Pph: Math.round(ParseDecimal(info.total_pph)),
      DiscPrcnt:
        deduction /
        /*info.total_before_discount_with_free-total_discount*/ totalMZF,
      items: detail,
    };

    if (validate(payload)) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-modena",
          cancelButton: "btn btn-readonly mr-3",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Confirmation",
          text: "Are you sure rehit this order ?",
          confirmButtonColor: "#3085d6",
          showCancelButton: true,
          confirmButtonText: "Yes",
          reverseButtons: true,
        })
        .then(({ isConfirmed }) => {
          if (isConfirmed) {
            setState({ ...state, loading: true });
            updateSO(state.order_id, payload)
              .then((res) => {
                const { data } = res.data;
                const base_url = REACT_APP_BASE_URL;
                if (info.deduction) {
                  const { DocNumSO } = data[0];
                  let payload = {
                    isHtml: true,
                    grand_total: NumberFormat(
                      Math.round(ParseDecimal(info.grand_total))
                    ),
                    total_before_discount: NumberFormat(
                      info.total_before_discount_with_free
                    ),
                    campaign_discount: info.total_discount,
                    deduction_amount: NumberFormat(
                      Math.round(ParseDecimal(deduction))
                    ),
                    id_so: DocNumSO,
                    deduction_remark: state.deduction_comment,
                    customer_name: info.nama_customer,
                    customer_address: info.address,
                    link_approval: `${base_url}salesorderapproval/view/${state.order_id}`,
                    link_detail: `${base_url}estatement/salesorder/${DocNumSO}`,
                  };
                  sendDeductionNotification(payload);
                }
                if (data.salesOrder && data.salesOrder?.status != 201) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: data.salesOrder.message,
                  }).then((res) => {
                    setState({ ...state, refresh: false });
                  });
                } else if (
                  data.invoice?.sap &&
                  data.invoice?.sap?.status != 201
                ) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: data.invoice.sap.message,
                  }).then((res) => {
                    setState({ ...state, refresh: true });
                  });
                } else if (
                  data.downPayment?.sap &&
                  data.downPayment?.sap?.status != 201
                ) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: data.downPayment.sap.message,
                  }).then((res) => {
                    setState({ ...state, refresh: true });
                  });
                } else if (
                  data.delivery?.sap &&
                  data.delivery?.sap?.status != 201
                ) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: data.delivery.sap.message,
                  }).then((res) => {
                    setState({ ...state, refresh: true });
                  });
                } else {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Update sales order success ",
                  }).then((res) => {
                    setState({ ...state, refresh: true });
                  });
                }
              })
              .catch((err) => {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: err?.response?.data.message || "Internal Server Error",
                }).then((res) => {
                  setState({ ...state, refresh: true });
                });
              })
              .finally(() => {
                setState({ ...state, loading: false });
              });
          }
        });
    }
  };

  const validate = (payload) => {
    let message = "";

    if (detail.length <= 0) {
      message = "Detail Item is not found!";
    } else if (state.province == "") {
      message = "Province required!";
    } else if (state.city == "") {
      message = "City required!";
    } else {
      let isExist = false;
      for (const key in detail) {
        if (detail[key].pph == "y") {
          isExist = true;
        }
      }

      if (isExist && info.pph_rate == 0) {
        message = "Please choose PPH..!";
      } else if (message != "") {
      } else {
        return true;
      }
    }
    if (message) {
      Swal.fire({
        title: "Invalid Data",
        text: message,
        icon: "error",
      });
      return false;
    }
  };

  const onChangeWarehouse = (e) => {
    const is_transit = e.target[e.target.selectedIndex].getAttribute("data-transit");
    const cardCode = e.target[e.target.selectedIndex].getAttribute("data-cardcode");
    const whs = e.target.value;
    let qty_indent =
      e.target[e.target.selectedIndex].getAttribute("data-stock");

    let {
      itemname,
      itemno,
      price,
      uom,
      qty_ready,
      qty_display,
      gudang_display,
      gudang_ready,
      type,
      paketid,
      grade,
    } = state.opsiProduct;

    if (is_transit === "true") {
      let payload = {
        mi_cardcode: cardCode,
        items: [
          {
            item: state.opsiProduct.itemno,
            comparator: state.opsiProduct.itemno,
            preorder: 1
          }
        ],
        whs: whs,
      }
      setState({ ...state, processing: true });
      getStockTransit(payload).then(res => {
        let dataStok = res.data;
        let index = dataStok[state.opsiProduct.itemno].findIndex(item => item.gudang === whs);

        let qtyNewIndent = dataStok[state.opsiProduct.itemno][index].stok;

        indent_warehouses.forEach((item, idx) => {
          if (item.WhsCode === whs) {
            indent_warehouses[idx].OnHand = qtyNewIndent;
          }
        });

        setState({
          ...state,
          showProduct: true,
          processing: false,
          opsiProduct: {
            itemname,
            itemno,
            price,
            qty: parseInt(qtyNewIndent) > 0 ? 1 : 0,
            type,
            paketid,
            gudang_indent: whs,
            qty_indent: parseInt(qtyNewIndent),
            qty_ready,
            qty_display,
            gudang_selected: whs,
            uom,
            gudang_display,
            gudang_ready,
            qty_selected: parseInt(qtyNewIndent),
            grade,
          },
        });
      }).catch(({ response: { data } }) => {
        handlerFormError(data);
        setState({ ...state, processing: false });
      })
    } else {
      $('[name="inlineRadioOptions"]').prop("checked", false);
      detail.forEach((datum) => {
        if (datum.itemno == itemno && datum.gudang == whs) {
          if (datum.type == "I") qty_indent -= parseInt(datum.qty);
        }
      });
      setState({
        ...state,
        showProduct: true,
        processing: false,
        opsiProduct: {
          itemname,
          itemno,
          price,
          qty: qty_indent > 0 ? 1 : 0,
          type,
          paketid,
          gudang_indent: whs,
          qty_indent,
          qty_ready,
          qty_display,
          gudang_selected: whs,
          uom,
          gudang_display,
          gudang_ready,
          qty_selected: qty_indent,
          grade,
        },
      });
    }
    /*let payload = {
            items : [
                {
                    item : state.opsiProduct.itemno.split(".")[0],
                    preorder : 0
                }
            ]
        }
        setState({...state, processing: true})
        getStokPO(payload).then(res => {
            let {gudang, stok} = res.data[state.opsiProduct.itemno];
            qty_indent = stok;

            detail.forEach( datum => {
                if(datum.itemno == itemno){
                    if(datum.type == "I" && datum.grade == grade) qty_indent -= parseInt(datum.qty);
                }
            })

            setState({
                ...state,
                showProduct: true,
                processing: false,
                opsiProduct: {
                    itemname,
                    itemno,
                    price,
                    qty: qty_indent > 0? 1: 0,
                    type: '',
                    paketid: '',
                    gudang_indent: gudang,
                    qty_indent,
                    qty_ready,
                    qty_display,
                    gudang_selected: '',
                    uom,
                    gudang_display,
                    gudang_ready,
                    qty_selected,
                    grade
                }
            });
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        })*/
  };

  const setRef = (el, row_id) => {
    modalAdditionalRef.current[row_id] = el;
  };

  const [statePreorder, setStatePreorder] = useState([]);
  const [statePreorderDetail, setStatePreorderDetail] = useState({});
  const getPreorderCampaign = async (itemDetail) => {
    setStatePreorderDetail({});
    document.querySelector("#modal-product-detail").style.display = "none";
    document.querySelector("#modal-product-preorder").style.display = "block";
    let payload = {
      BPLId: "BRANCH|" + userInfo.BPLId + "|" + userInfo.BPLName,
      ItemCode: itemDetail.itemno,
      OrderType: "FGSPREO",
    };
    const res = await getPromo(payload);
    if (res.status === 200) {
      setStatePreorder(res.data.data);
      //console.log('statePERIORDER',statePreorder);
    }
  };

  const backFromPreorderCampaign = () => {
    document.querySelector("#modal-product-detail").style.display = "block";
    document.querySelector("#modal-product-preorder").style.display = "none";
  };

  const detailPreorderCampaign = async (campaign, item_id, dealer_id) => {
    const res = await getPromoDetail(campaign, item_id, dealer_id);
    if (res.status === 200) {
      let _kuota_terpakai = kuota_terpakai(campaign, item_id);
      res.data.kuota -= _kuota_terpakai;
      setStatePreorderDetail(res.data);
      setStatePreorderQty(1);
    }
  };

  const kuota_terpakai = (campaign, item_id) => {
    let qty = 0;
    detail.forEach((datum) => {
      if (datum.itemno == item_id && datum.paketid == campaign) {
        qty += parseInt(datum.qty);
      }
    });
    return qty;
  };

  const [statePreorderQty, setStatePreorderQty] = useState(1);
  const onChangeQtyPreorder = (e, kuota) => {
    setStatePreorderQty(
      e.target.value < 1 ? 1 : e.target.value > kuota ? kuota : e.target.value
    );
  };

  const addProductDetailPreorder = (item, statePreorderDetail) => {
    let payload = {
      itemno: item.itemno,
      itemname: item.itemname,
      qty: statePreorderQty,
      price: item.price,
      uom: item.uom,
      type: "I",
      grade: "A",
      preorder: true,
      gudang_selected: "GDGPRO",
      M_TP_PENJ: "FGS",
      ShipToDesc: info.address,
      M_DISC_1: userInfo.net_discount,
      M_DISC_2: 0,
      M_DISC_3: 0,
      M_DISC_4: 0,
      Delivery: 0,
      ShipToCode: state.ShipToCode,
      M_KD_CMPG: statePreorderDetail.paketid,
      M_KET_CMPG: statePreorderDetail.keterangan_paket,
      dealer_id: userInfo.MI_cardcode.filter(
        (order_type) => order_type.U_M_TP_TRSKS === "FGS"
      )[0].U_M_BP_CODE_MI,
    };
    addProductDetail(payload);
    document.querySelector("#modal-product-preorder").style.display = "none";
    document.querySelector("#modal-product-detail").style.display = "block";
  };

  //const listpph = () => getPPH({filter: `WTName:%${userInfo.BPLName}%`});
  const listpph = () => getCustomerPph({ CardCode: info.kode_customer });
  const propsTable = {
    columns,
    getData: getCustomerAll,
    showIndex: true,
    showAddButton: true,
    onAddData,
    order: "CardName",
    direction: "desc",
  };
  const propsTableProduct = {
    columns: columns_product,
    getData: getListProduk,
    showIndex: true,
    order: "ItemName",
    direction: "desc",
    searchBarWidth: "9",
  };
  const propsTablePPH = {
    columns: columns_pph,
    getData: listpph,
    showIndex: true,
    rowClick: onRowClickPPH,
    rowSelector: "WTCode",
    order: "WTCode",
    direction: "desc",
  };
  const propsPrint = {
    getState: state,
    getInfo: info,
    login: info.user_information,
  };

  return (
    <div className="content-wrapper">
      <Overlay display={state.loading} />
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <h2 className="title-breadcrum">
                {pageState == "create"
                  ? "Create Sales Order"
                  : "Sales Order #" + state.order_no}{" "}
                &nbsp;
                {info.status_so == "Reject" ? (
                  <span className="badge bg-red me-2">REJECT</span>
                ) : info.status_so == "Paid" ? (
                  <span className="badge bg-paid me-2">PAID</span>
                ) : info.status_so == "Closed" &&
                  info.payment_verified === null ? (
                  <span className="badge bg-close me-2">CLOSED</span>
                ) : info.status_so == "Pending" ? (
                  <span className="badge bg-teal me-2">PENDING</span>
                ) : info.status_so == "Cancelled" ? (
                  <span className="badge bg-red me-2">CANCELLED</span>
                ) : info.payment_verified === true &&
                  info.status_so == "Closed" ? (
                  <span className="badge bg-green me-2">VERIFIED</span>
                ) : info.payment_verified === false &&
                  info.status_so == "Closed" ? (
                  <span
                    className="badge bg-red me-2"
                    style={{ fontSize: "12px" }}
                  >
                    NOT VERIFIED
                  </span>
                ) : info.status_so == "Open" ? (
                  <span className="badge bg-cyan me-2">OPEN</span>
                ) : (
                  ""
                )}
                {state.order_id != "" &&
                  state.order_id &&
                  //userInfo.role_name !== "SO Payment Verificator" &&
                  userInfo.role_name !==
                  "SO Payment Verificator - MHC Dealer" &&
                  info.status_so !== "Cancelled" &&
                  state.order_no.substring(0, 3) !== "TMP" && (
                    <>
                      <div style={{ display: "none" }}>
                        <PrintSO ref={componentRef} {...propsPrint} />
                      </div>
                      <div style={{ float: "right", cursor: "pointer" }}>
                        <img src={print} onClick={handlePrint} />
                      </div>
                    </>
                  )}
                {showbtnresubmitpo &&
                  userInfo.role_name !== "SO Payment Verificator" &&
                  userInfo.role_name !==
                  "SO Payment Verificator - MHC Dealer" && (
                    <div class="float">
                      <button
                        className="btn btn-modena my-float"
                        style={{ marginBottom: 30 }}
                        type="button"
                        onClick={onResubmitPO}
                      >
                        <span className="fa fa-redo"></span> <br />
                        Submit PO
                      </button>
                    </div>
                  )}
              </h2>
              <h5>
                {state.docnum != "" && (
                  <div style={{ float: "left" }}>Doc No. #{state.docnum}</div>
                )}
                {info.status_so != "Open" &&
                  info.status_so != "Cancelled" &&
                  warehouseCount.ready_count > 0 && (
                    <div
                      style={{
                        float: "left",
                        marginLeft: 10,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      | Inv No. #{rehitButtonsState.inv_number || "-"} &nbsp;{" "}
                      {rehitButtonsState.invoice_rehit == true &&
                        state.docnum &&
                        state.docnum != "-" && (
                          <a
                            style={{
                              fontSize: "14px",
                              cursor: "pointer",
                              color: "blue",
                            }}
                            onClick={() => {
                              rehitInvoice(state.order_id).then((res) => {
                                /*if (res.data.status == 201) {
                              Swal.fire({
                                icon: "success",
                                title: "Success",
                                text: res.data.message,
                              }).then((_) => {
                                navigate(0);
                              });
                            } else {*/
                                let message = "";
                                if (res?.data?.message)
                                  message +=
                                    "Invoice header info: " +
                                    res.data.message +
                                    "<br/>";
                                if (res?.data?.data?.items?.message)
                                  message +=
                                    "Invoice detail info: " +
                                    res.data.data.items.message +
                                    "<br/>";
                                if (res?.data?.sap) {
                                  const sap_message =
                                    typeof res.data.sap.message === "string"
                                      ? res.data.sap.message
                                      : JSON.parse(res.data.sap.message);

                                  message +=
                                    "<br/> SAP Message : <span style='color:red;'>" +
                                    sap_message +
                                    "</span><br/>";
                                }
                                Swal.fire({
                                  icon: "info",
                                  title: "Invoice Creation Info",
                                  html: "Details:<br/>" + message,
                                }).then((_) => {
                                  navigate(0);
                                });
                                //}
                              });
                            }}
                          >
                            <i className="fas fa-sync-alt" />
                            Rehit Invoice
                          </a>
                        )}

                    </div>
                  )}
                {info.status_so != "Open" &&
                  info.status_so != "Cancelled" &&
                  warehouseCount.indent_count > 0 && (
                    <div
                      style={{
                        float: "left",
                        marginLeft: 10,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      | DP No. #{rehitButtonsState.dp_number || "-"}&nbsp;{" "}
                      {rehitButtonsState.dp_rehit == true &&
                        state.docnum &&
                        state.docnum != "-" && (
                          <a
                            style={{
                              fontSize: "14px",
                              cursor: "pointer",
                              color: "blue",
                            }}
                            onClick={() => {
                              rehitDP(state.order_id).then((res) => {
                                let message = "";
                                if (res?.data?.message)
                                  message +=
                                    "<br/> DP header info: " +
                                    res.data.message +
                                    "<br/>";
                                if (res?.data?.data?.items?.message)
                                  message +=
                                    "<br/> DP detail info: " +
                                    res.data.data.items.message +
                                    "<br/>";
                                if (res?.data?.sap) {
                                  const sap_message =
                                    typeof res.data.sap.message === "string"
                                      ? res.data.sap.message
                                      : "-";

                                  message +=
                                    "<br/> SAP Message : <span style='color:red;'>" +
                                    sap_message +
                                    "</span><br/>";
                                }
                                Swal.fire({
                                  icon: "info",
                                  title: "DP Creation Info",
                                  html: "Details:<br/>" + message,
                                }).then((_) => {
                                  navigate(0);
                                });
                                //}
                              });
                            }}
                          >
                            <i className="fas fa-sync-alt" />
                            Rehit DP
                          </a>
                        )}
                    </div>
                  )}
                {state.with_ip && (
                  <>
                    <span style={{ marginLeft: 10, marginRight: 10 }}>
                      | IP No. #{state.ip_doc_entry || "-"}
                    </span>
                    {!state.ip_doc_entry && (
                      <a
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                          color: "blue",
                        }}
                        onClick={() => {
                          hitIncomingPayment(state.order_id).then((res) => {
                            if (res.data.status == 201 || res.data.status == 200) {
                              Swal.fire({
                                icon: "success",
                                title: "Success",
                                text: res.data.message,
                              }).then((_) => {
                                navigate(0);
                              });
                            }
                          }).catch((err) => {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: err?.response?.data?.message || "Internal Server Error",
                            });
                          });
                        }}
                      >
                        <i className="fas fa-sync-alt" />
                        &nbsp; {" "} Rehit IP
                      </a>
                    )}
                  </>
                )}
                <div style={{ float: "right" }}>
                  Date {moment(info.created_date).format("DD MMMM YYYY")}
                </div>
              </h5>
            </div>
          </div>
        </div>
      </div >
      <section className="content">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3 bg-white">
              <h6 className="m-0 title-breadcrum tx-gray">Info Customer</h6>
            </div>
            <div className="card-body">
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-6">
                  {pageState == "create" ||
                    state.order_no.substring(0, 3) == "TMP" ? (
                    <MInput
                      name="name"
                      label="Name/ID"
                      type="text"
                      role="button"
                      icon={<i className="bi bi-people"></i>}
                      readOnly
                      defaultValue={info.nama_customer}
                      onClick={onShowModal}
                      required
                    />
                  ) : (
                    <MInput
                      name="name"
                      label="Name/ID"
                      type="text"
                      icon={<i className="bi bi-people"></i>}
                      readOnly
                      defaultValue={info.nama_customer}
                      required
                    />
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="mb-3">
                    <MInput
                      id="delivery_date"
                      name="delivery_date"
                      label="Delivery Date"
                      type="date"
                      readOnly={locked}
                      value={info.delivery_date || moment().format("YYYY-MM-DD")}
                      icon={<i className="bi bi-calendar3"></i>}
                      onChange={onDateDeliveryChange}
                      required
                      disabled={info.status_so === "Cancelled"}
                    />
                  </div>
                </div>
                {/* <div className='col-sm-3'>
                                    <div className="mb-3">
                                        <MSelect label='Order Type' options={info.ordertype} value={state.order_type} onChange={setChangeOrderType} disabled={locked} />
                                    </div>
                                </div> */}
              </div>
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-4">
                  <MInput
                    name="phone"
                    label="Phone Number"
                    type="text"
                    icon={<i className="bi bi-phone"></i>}
                    readOnly
                    defaultValue={info.phone ? "+62" + info.phone : ""}
                    required
                  />
                </div>
                <div className="col-sm-4">
                  <div className="mb-3">
                    <MInput
                      name="email"
                      label="Email"
                      type="email"
                      icon={<i className="bi bi-envelope"></i>}
                      readOnly
                      defaultValue={info.email}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <MInput
                    name="npwp"
                    label="NPWP"
                    type="text"
                    icon={<i className="bi bi-file-text"></i>}
                    readOnly={locked}
                    defaultValue={info.npwp || ""}
                    onChange={onNpwpChange}
                  />
                </div>

              </div>
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-12">
                  <div className="mb-3">
                    <MTextarea
                      label="Address"
                      name="Address"
                      icon={<i className="bi bi-geo-alt"></i>}
                      rows={3}
                      readOnly
                      value={info.address}
                    />
                  </div>
                </div>
              </div>
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-4">
                  <div className="mb-3">
                    <MSelect
                      label="Country"
                      options={options}
                      value={state.county}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="mb-3">
                    <MSelect
                      label="Province"
                      options={info.country}
                      value={state.province}
                      onChange={setChangeProv}
                      disabled={true}
                    />
                  </div>
                </div>
                {/*spec-666*/}
                <div className="col-sm-4">
                  <div className="mb-3">
                    <MSelect
                      label="City"
                      options={info.province}
                      value={state.city}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div id="modal-pph" className="modal">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title"> List PPH</h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>

                    <div className="modal-body">
                      {info.kode_customer && (
                        <MTable ref={mTablePPH} {...propsTablePPH} />
                      )}
                      {info.kode_customer == "" && (
                        <span>Please Select Customer First</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div id="modal-detail" className="modal">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title"> List Customer</h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <MTable ref={mTableC} {...propsTable} />
                    </div>
                  </div>
                </div>
              </div>
              <Modal id="modal-promo">
                <Overlay display={state.processing} />
                <ModalPromo listPromo={state.listPromo} onHandleClick={onUse} />
              </Modal>
              <Modal id="modal-promo-header">
                <ModalPromo
                  listPromo={state.listPromo}
                  withCode={true}
                  onHandleClick={onUse}
                  __DMCalculation={DMCalculation}
                />
              </Modal>
              <div id="modal-deduction" className="modal">
                <Overlay display={state.processing} />
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Additional Deduction</h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={submitDeduction()}>
                        <div className="row" style={{ padding: "10px 15px" }}>
                          <div className="col-sm-4">
                            <label>Discount*</label>
                            <div className="input-group input-group-joined">
                              <select
                                name="deduction_by"
                                className="form-control ps-0"
                                ref={deductionType}
                                onChange={onChangeTypeDeduction}
                              >
                                <option value="Amount">Amount</option>
                                <option value="Percent">Percent</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-sm-8">
                            <label>&nbsp;(Include Tax - only for PKP)</label>
                            <div className="input-group input-group-joined">
                              {/* <input className="form-control ps-0" type="number" min={0} ref={deductionAmount}  /> */}
                              <CurrencyInput
                                className="form-control ps-0"
                                decimalSeparator=","
                                groupSeparator="."
                                decimalsLimit={0}
                                // ref={deductionAmount}
                                value={Math.round(deduction_amount)}
                                allowNegativeValue={false}
                                style={{ textAlign: "right" }}
                                defaultValue={0}
                                maxLength={deduction_type == "Percent" ? 3 : 12}
                                onValueChange={(value, name) =>
                                  onChangeDeductionAmount(value, name)
                                }
                                placeholder="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ padding: "10px 15px" }}>
                          <div className="col-sm-12">
                            <label>Comment / Reason For Deduction</label>
                            <div className="input-group input-group-joined">
                              <textarea
                                maxLength={100}
                                className="form-control"
                                rows={3}
                                value={state.deduction_comment}
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    deduction_comment: e.target.value,
                                  })
                                }
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ padding: "10px 15px" }}>
                          <div className="col-sm-4">
                            <button
                              className="btn btn-readonly btn-block"
                              style={{ marginBottom: 30 }}
                              type="button"
                              onClick={onClearDeduction}
                            >
                              Clear
                            </button>
                          </div>
                          <div className="col-sm-8">
                            <button
                              className="btn btn-modena btn-block"
                              style={{ marginBottom: 30 }}
                              type="submit"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div id="modal-form" className="modal">
                <Overlay display={state.processing} />
                <form name="form-customer" onSubmit={handleSubmit(onSubmit)}>
                  <div
                    className="modal-dialog modal-dialog-centered modal-lg"
                    style={{ minWidth: 1200 }}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {" "}
                          {state.customer.cardid !== ""
                            ? "Edit Customer"
                            : "New Customer"}
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="row" style={{ padding: "10px 65px" }}>
                          <div className="col-sm-12">
                            <div className="">
                              <label>Name/ID</label>
                              <div className="input-group input-group-joined">
                                <span className="input-group-text ">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-people"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
                                  </svg>
                                </span>
                                <input
                                  className="form-control ps-0"
                                  {...register("CardName", {
                                    required: {
                                      value: true,
                                      message: "Name is required!",
                                    },
                                  })}
                                  type="text"
                                  aria-label="Search"
                                />
                              </div>
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.CardName && errors.CardName.message}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ padding: "10px 65px" }}>
                          <div className="col-sm-6">
                            <div>
                              <label>Email</label>
                              <div className="input-group input-group-joined">
                                <span className="input-group-text ">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-envelope"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                                  </svg>
                                </span>
                                <input
                                  className="form-control ps-0"
                                  {...register("EmailAddress", {
                                    required: {
                                      value: true,
                                      message: "Email is required!",
                                    },
                                    pattern: {
                                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                      message: "Invalid email format!",
                                    },
                                    validate: (value) => {
                                      // Tidak boleh diawali minus
                                      if (/^-/.test(value)) return "Email must not start with -";
                                      // Tidak boleh ada titik di akhir local-part
                                      const [local] = value.split("@");
                                      if (local.endsWith(".")) return "Email local-part must not end with .";
                                      // Tidak boleh ada \ atau /
                                      if (value.includes("\\") || value.includes("/")) return "Email must not contain \\ or /";
                                      return true;
                                    },
                                  })}
                                  type="text"
                                  placeholder=""
                                  aria-label="Search"
                                />
                              </div>
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.EmailAddress &&
                                  errors.EmailAddress.message}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="">
                              <label>
                                Phone Number (country code will be included)
                              </label>
                              <div className="input-group input-group-joined">
                                <span className="input-group-text ">
                                  <i className="bi bi-phone"></i>
                                </span>
                                <input
                                  className="form-control ps-0"
                                  pattern="[0-9]*"
                                  {...register("Phone1", {
                                    required: {
                                      value: true,
                                      message: "Phone is required!",
                                    },
                                  })}
                                  type="text"
                                  onChange={onChangePhone}
                                  placeholder=""
                                />
                              </div>
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.Phone1 && errors.Phone1.message}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ padding: "10px 65px" }}>
                          <div className="col-sm-12">
                            <div className="">
                              <label>Address</label>
                              <div className="input-group input-group-joined">
                                <span className="input-group-text ">
                                  <i className="bi bi-geo-alt"></i>
                                </span>
                                <textarea
                                  maxLength={100}
                                  className="form-control"
                                  rows={3}
                                  {...register("Address", {
                                    required: {
                                      value: true,
                                      message: "Address is required!",
                                    },
                                  })}
                                ></textarea>
                              </div>
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.Address && errors.Address.message}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ padding: "10px 65px" }}>
                          <div className="col-sm-4">
                            <div className="">
                              <label>Country</label>
                              <div className="input-group input-group-joined">
                                <select
                                  className="form-control"
                                  {...register("form_country", {
                                    required: {
                                      value: true,
                                      message: "Country is required!",
                                    },
                                  })}
                                >
                                  <option value="ID">INDONESIA</option>
                                </select>
                              </div>
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.form_country &&
                                  errors.form_country.message}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="">
                              <label>Province</label>
                              <div className="input-group input-group-joined">
                                <select
                                  className="form-control"
                                  {...register("form_province", {
                                    required: {
                                      value: true,
                                      message: "Province is required!",
                                    },
                                  })}
                                  onChange={setChange}
                                >
                                  <option value="">Select Province</option>
                                  {info.country.map((county, i) => (
                                    <option
                                      key={`prov-` + i}
                                      value={county.value}
                                    >
                                      {county.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.form_province &&
                                  errors.form_province.message}
                              </span>
                            </div>
                          </div>
                          {/*spec-667*/}
                          <div className="col-sm-4">
                            <div className="">
                              <label>City</label>
                              <div className="input-group input-group-joined">
                                <select
                                  className="form-control"
                                  {...register("form_city", {
                                    required: {
                                      value: true,
                                      message: "City is required!",
                                    },
                                  })}
                                  onChange={setChangeCity}
                                >
                                  <option value="">Select City</option>
                                  {info.province.length > 0 &&
                                    info.province.map((prov, i) => (
                                      <option
                                        key={`city-` + i}
                                        value={prov.value}
                                      >
                                        {prov.label}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.form_city && errors.form_city.message}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn btn-outline-dark"
                          data-dismiss="modal"
                        >
                          <i className="fa fa-times"></i> Close
                        </button>
                        <button
                          type="submit"
                          className="btn btn-dark"
                          disabled={state.customer_saving}
                        >
                          <i className="fa fa-save"></i> Save
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div id="modal-product" className="modal">
                <form name="form-product">
                  <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title"> Product List</h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-7 col-xl-8">
                            <MTable ref={mTableP} {...propsTableProduct} />
                          </div>
                          <div className="col-md-5 col-xl-4">
                            <Overlay display={state.processing} />
                            <div className="card">
                              <div className="card-header card-header-product">
                                Detail Product
                              </div>
                              <div
                                className="card-body"
                                style={{ minHeight: 250 }}
                                id="modal-product-detail"
                              >
                                {!state.showProduct ? (
                                  <div>
                                    <div className="row h-100 justify-content-center align-items-center">
                                      <i
                                        className="bi bi-x-circle-fill"
                                        style={{ fontSize: 50 }}
                                      ></i>
                                    </div>
                                    <br />
                                    <p style={{ textAlign: "center" }}>
                                      Product not found! <br />
                                      Please Select Product
                                    </p>
                                  </div>
                                ) : (
                                  <div>
                                    <div className="row h-100 justify-content-center align-items-center">
                                      <p className="title-choose-produk">
                                        {state.opsiProduct.itemname}
                                        <br />({state.opsiProduct.itemno})
                                      </p>
                                      <div className="mb-3">
                                        {/*<p className='title-choose-produk'>Choose Grade (for <b>indent</b> items only):</p>
                                                                                    <p className='title-choose-produk'>Gudang:{state.opsiProduct.gudang_indent}</p>*/}
                                        <label>
                                          Select Sales Event (for indent
                                          products):{" "}
                                        </label>
                                        <select
                                          className="form-control ps-0"
                                          onChange={onChangeSOEventType}
                                          style={{ marginBottom: "11px" }}
                                          id="soEventType"
                                          value={stateEventType}
                                        >
                                          <option value="FGS">Reguler</option>
                                          <option value="PMR">Pameran</option>
                                        </select>
                                        <label>
                                          Select Grade (for indent products):{" "}
                                        </label>
                                        <select
                                          className="form-control ps-0"
                                          onChange={onChangeGrade}
                                          id="soItemGrade"
                                          value={stateGrade}
                                        >
                                          <option value="A">Grade A</option>
                                          <option value="B">Grade B</option>
                                          <option value="K">Grade K</option>
                                        </select>
                                      </div>
                                      {state.opsiProduct.type === "I" && (
                                        <>
                                          <div className="col-sm-10 mb-3">
                                            {/*<p className='title-choose-produk'>Choose Grade (for <b>indent</b> items only):</p>
                                                                                    <p className='title-choose-produk'>Gudang:{state.opsiProduct.gudang_indent}</p>*/}
                                            <label>Select Warehouse: </label>
                                            <select
                                              className="form-control ps-0"
                                              onChange={(e) =>
                                                onChangeWarehouse(e)
                                              }
                                              value={state.opsiProduct.gudang_selected}
                                              disabled={
                                                !indent_warehouses ||
                                                indent_warehouses.length <= 0
                                              }
                                            >
                                              {indent_warehouses.map((item) => {
                                                return (
                                                  <option
                                                    value={item.WhsCode}
                                                    data-stock={item.OnHand}
                                                    data-transit={item.Transit}
                                                    data-cardcode={item.CardCode}
                                                  >
                                                    {item.WhsCode}
                                                  </option>
                                                );
                                              })}
                                              {/* <option value='C'>Grade C</option> */}
                                            </select>
                                          </div>
                                        </>
                                      )}
                                      {!includes(
                                        userInfo.role_name,
                                        "MHC Dealer"
                                      ) && (
                                          <div className="col-sm-4">
                                            <div
                                              className="form-check form-check-inline"
                                              style={{
                                                textAlign: "center",
                                                paddingLeft: 0,
                                                display: "block",
                                              }}
                                            >
                                              <input
                                                className="form-check-input radio-helper"
                                                type="radio"
                                                name="inlineRadioOptions"
                                                id="inlineRadio1"
                                                value="D"
                                                onChange={(e) =>
                                                  onRadioChange(
                                                    e,
                                                    state.opsiProduct
                                                      .gudang_display,
                                                    state.opsiProduct.qty_display
                                                  )
                                                }
                                                checked={
                                                  state.opsiProduct.type == "D"
                                                }
                                                disabled={
                                                  state.opsiProduct.qty_display <
                                                  1
                                                }
                                              />
                                              <br />
                                              <label
                                                className="form-check-label"
                                                htmlFor="inlineRadio1"
                                              >
                                                Display
                                              </label>
                                              <span className="angka-stock">
                                                {state.opsiProduct.qty_display > 0
                                                  ? state.opsiProduct.qty_display
                                                  : 0}
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                      {!includes(
                                        userInfo.role_name,
                                        "MHC Dealer"
                                      ) && (
                                          <div className="col-sm-4">
                                            <div
                                              className="form-check form-check-inline"
                                              style={{
                                                textAlign: "center",
                                                paddingLeft: 0,
                                                display: "block",
                                              }}
                                            >
                                              <input
                                                className="form-check-input radio-helper"
                                                type="radio"
                                                name="inlineRadioOptions"
                                                id="inlineRadio2"
                                                value="R"
                                                onChange={(e) =>
                                                  onRadioChange(
                                                    e,
                                                    state.opsiProduct
                                                      .gudang_ready,
                                                    state.opsiProduct.qty_ready
                                                  )
                                                }
                                                checked={
                                                  state.opsiProduct.type == "R"
                                                }
                                                disabled={
                                                  state.opsiProduct.qty_ready < 1
                                                }
                                              />
                                              <br />
                                              <label
                                                className="form-check-label"
                                                htmlFor="inlineRadio2"
                                              >
                                                Ready
                                              </label>
                                              <br />
                                              <span className="angka-stock">
                                                {state.opsiProduct.qty_ready > 0
                                                  ? state.opsiProduct.qty_ready
                                                  : 0}
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                      <div className="col-sm-4">
                                        <div
                                          className="form-check form-check-inline"
                                          style={{
                                            textAlign: "center",
                                            paddingLeft: 0,
                                            display: "block",
                                          }}
                                        >
                                          <input
                                            className="form-check-input radio-helper"
                                            type="radio"
                                            name="inlineRadioOptions"
                                            id="inlineRadio3"
                                            value="I"
                                            checked={
                                              state.opsiProduct.type == "I"
                                            }
                                            onChange={(e) =>
                                              onRadioChange(
                                                e,
                                                state.opsiProduct.gudang_indent,
                                                state.opsiProduct.qty_indent
                                              )
                                            }
                                            disabled={
                                              state.opsiProduct.qty_indent < 1 && state.opsiProduct.type == "I"
                                            }
                                          />
                                          <br />
                                          <label
                                            className="form-check-label"
                                            htmlFor="inlineRadio3"
                                          >
                                            Indent
                                          </label>
                                          <span className="angka-stock">
                                            {state.opsiProduct.qty_indent > 0
                                              ? state.opsiProduct.qty_indent
                                              : 0}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="row"
                                      style={{ marginTop: 30 }}
                                    >
                                      <div className="col-sm-5 col-md-8 mx-auto pl-0 pr-0">
                                        <div className="qty-box">
                                          <span
                                            className="minus-box bg-dark"
                                            onClick={() => minus()}
                                          >
                                            -
                                          </span>
                                          <input
                                            type="number"
                                            className="input-qty counter"
                                            min={1}
                                            name="qty"
                                            value={state.opsiProduct.qty}
                                            onChange={(event) =>
                                              onChangeQty(event)
                                            }
                                            max={state.opsiProduct.qty_selected}
                                          />
                                          <span
                                            className="plus-box bg-dark"
                                            onClick={() => plus()}
                                          >
                                            +
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-sm-7 col-md-12 pl-0 pr-0 pt-2">
                                        <p className="price pt-1">
                                          IDR{" "}
                                          {NumberFormat(
                                            state.opsiProduct.price
                                          )}
                                        </p>
                                      </div>
                                      {state.opsiProduct?.locked === "Y" && (
                                        <div className="col-sm-7 col-md-12 pl-0 pr-0 pt-2">
                                          <p
                                            className="price pt-1"
                                            style={{
                                              color: "orangered",
                                              backgroundColor: "#fde3b7",
                                              border: "solid",
                                            }}
                                          >
                                            This indent Item locked by DM.
                                            <br />
                                            Real Stock :{" "}
                                            {state.opsiProduct.qty_unlock}
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                    <div className="row h-100 justify-content-center align-items-center mt-4">
                                      <button
                                        className="btn btn-dark"
                                        disabled={
                                          !state.enable_add_product_detail
                                        }
                                        style={{ width: "100%" }}
                                        type="button"
                                        onClick={() =>
                                          addProductDetail(state.opsiProduct)
                                        }
                                      >
                                        <span className="fas fa-plus"></span>{" "}
                                        Add Product
                                      </button>
                                      <button
                                        className="btn btn-dark"
                                        disabled={
                                          !state.enable_add_product_detail
                                        }
                                        style={{ width: "100%", marginTop: 10 }}
                                        type="button"
                                        onClick={() =>
                                          getPreorderCampaign(state.opsiProduct)
                                        }
                                      >
                                        Get Preorder
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div
                                className="card-body"
                                style={{ minHeight: 250, display: "none" }}
                                id="modal-product-preorder"
                              >
                                <div>
                                  <div className="row h-100 justify-content-center align-items-center">
                                    <p className="title-choose-produk">
                                      {state.opsiProduct.itemname}
                                      <br />({state.opsiProduct.itemno})
                                    </p>
                                  </div>
                                  Preorder Campaign Available
                                  <div
                                    style={{
                                      paddingTop: "17px",
                                      paddingBottom: "17px",
                                    }}
                                  >
                                    {statePreorder.map((item, index) => {
                                      let dealer_id =
                                        userInfo.MI_cardcode.filter(
                                          (order_type) =>
                                            order_type.U_M_TP_TRSKS === "FGS"
                                        )[0].U_M_BP_CODE_MI;
                                      return (
                                        <div
                                          style={{
                                            textAlign: "left",
                                            paddingBottom: "17px",
                                          }}
                                        >
                                          <span>
                                            <span
                                              style={{ fontWeight: "bold" }}
                                            >
                                              #{index + 1}{" "}
                                              <a
                                                href="javascript:void(0)"
                                                onClick={() =>
                                                  detailPreorderCampaign(
                                                    item.paketid,
                                                    state.opsiProduct.itemno,
                                                    dealer_id,
                                                    index
                                                  )
                                                }
                                              >
                                                {item.paketid}
                                              </a>
                                            </span>
                                            <br />
                                            {item.keterangan_paket}
                                          </span>
                                          {statePreorderDetail.paketid ===
                                            item.paketid && (
                                              <div>
                                                <span
                                                  style={{ fontWeight: "bold" }}
                                                >
                                                  Kuota:{" "}
                                                  {statePreorderDetail.kuota}
                                                </span>
                                                <br />
                                                <div style={{ display: "flex" }}>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    disabled={
                                                      statePreorderDetail.kuota <=
                                                        0
                                                        ? true
                                                        : false
                                                    }
                                                    placeholder="Qty"
                                                    style={{
                                                      width: "50%",
                                                      borderTopRightRadius: "0",
                                                      borderBottomRightRadius:
                                                        "0",
                                                    }}
                                                    value={
                                                      statePreorderDetail.kuota <=
                                                        0
                                                        ? 0
                                                        : statePreorderQty
                                                    }
                                                    onChange={(e) =>
                                                      onChangeQtyPreorder(
                                                        e,
                                                        statePreorderDetail.kuota
                                                      )
                                                    }
                                                  />
                                                  <button
                                                    className="btn btn-dark"
                                                    disabled={
                                                      statePreorderDetail.kuota <=
                                                        0
                                                        ? true
                                                        : false
                                                    }
                                                    style={{
                                                      width: "50%",
                                                      borderTopLeftRadius: "0",
                                                      borderBottomLeftRadius: "0",
                                                    }}
                                                    type="button"
                                                    onClick={() =>
                                                      addProductDetailPreorder(
                                                        state.opsiProduct,
                                                        statePreorderDetail
                                                      )
                                                    }
                                                  >
                                                    Add Product
                                                  </button>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <button
                                    className="btn btn-dark"
                                    disabled={!state.enable_add_product_detail}
                                    style={{ width: "100%", marginTop: 10 }}
                                    type="button"
                                    onClick={() => backFromPreorderCampaign()}
                                  >
                                    Back
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {info.detail && info.detail.length > 0 && (
            <>
              <div className="card shadow mb-4">
                <div className="card-header py-3 bg-white">
                  <div className="row">
                    <div className="col-sm-8">
                      <h6 className="m-0 title-breadcrum tx-gray">
                        Detail Product
                      </h6>
                    </div>
                    <div className="col-sm-4 text-right">
                      D : Display R : Ready I : Indent
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-hover"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th className="th-no-border"></th>
                          <th className="th-no-border">No</th>
                          <th className="th-no-border">Product</th>
                          <th className="th-no-border">WHS</th>
                          <th className="th-no-border">Qty</th>
                          <th className="th-no-border"></th>
                          <th className="th-no-border">Grade</th>
                          <th className="th-no-border">Currency</th>
                          <th className="th-no-border">Price / Unit</th>
                          <th className="th-no-border">Net / Disc</th>
                          <th className="th-no-border">PPN</th>
                          <th className="th-no-border">PPH</th>
                          <th className="th-no-border">Gross Total</th>
                          <th className="th-no-border">Order Type</th>
                          <th className="th-no-border"></th>
                          <th className="th-no-border">Delivery</th>
                          {/*<th className='th-no-border'>Additional Address</th>*/}
                        </tr>
                      </thead>

                      <tbody>
                        {detail.map((row, index) => (
                          <>
                            <tr key={`tr-` + index}>
                              <td>
                                {row.free == 0 &&
                                  locked == false &&
                                  info.status_so !== "Cancelled" && (
                                    <div
                                      style={{ border: 2, cursor: "pointer" }}
                                      onClick={() => onRemoveProduct(row)}
                                    >
                                      <img src={trash} />
                                    </div>
                                  )}
                              </td>
                              <td>{row.free == 0 ? row.urut : ""}</td>
                              <td>
                                <label
                                  style={{
                                    textAlign: "center",
                                    display: "block",
                                  }}
                                >
                                  {row.itemname} ({row.itemno})
                                </label>
                                {/*row.type == "I" && <span style={{display: "inline-block", marginTop:"5px", fontSize:"14px"}}><b>Ship To:</b> <br/> {row.ShipToDesc} ({row.ShipToCode})</span>*/}
                              </td>
                              <td>{row.gudang}</td>
                              <td width={60}>
                                <label
                                  style={{
                                    textAlign: "center",
                                    display: "block",
                                  }}
                                >
                                  {row.qty}
                                </label>
                              </td>
                              <td width={20}>
                                <label>{row.type}</label>
                              </td>
                              <td width={20}>
                                <label>{row.grade}</label>
                              </td>
                              <td width={50}>
                                <label>IDR</label>
                              </td>
                              <td width={150} style={{ textAlign: "right" }}>
                                {(!includes(userInfo.role_name, "MHC Dealer") ||
                                  includes(
                                    userInfo.role_name,
                                    "Payment Verificator"
                                  )) &&
                                  !row.edit_price_allowed && (
                                    <label> {NumberFormat(row.price)}</label>
                                  )}
                                {includes(userInfo.role_name, "MHC Dealer") &&
                                  !includes(
                                    userInfo.role_name,
                                    "Payment Verificator"
                                  ) &&
                                  !row.edit_price_allowed && (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: "10px",
                                      }}
                                    >
                                      <div> {NumberFormat(row.price)}</div>
                                      {/*!locked && <i className="fa fa-edit" style={{color:"green", cursor:"pointer"}} onClick={(e) => {
                                                                    const det = [...detail]
                                                                    det[index].edit_price_allowed = true;
                                                                    setInfo({
                                                                        ...info,
                                                                        detail:det
                                                                    })
                                                                }}></i>*/}
                                    </div>
                                  )}
                                {/*includes(userInfo.role_name, "MHC Dealer") && row.edit_price_allowed && <div style={{display:"flex", alignItems:"center", columnGap:"10px"}}>
                                                                <input pattern="\d+"  type="number" onChange={(e) => onChangePrice(e, index)} placeholder={row.price} disabled={!row.edit_price_allowed}/>
                                                                <i className="fa fa-check" style={{color:"green", cursor:"pointer"}} onClick={(e) => onSubmitPrice(prices[index], index, row)}></i>
                                                            </div>*/}
                              </td>
                              <td width={80}>
                                {(!includes(userInfo.role_name, "MHC Dealer") ||
                                  includes(
                                    userInfo.role_name,
                                    "Payment Verificator"
                                  )) &&
                                  !row.edit_disc_allowed && (
                                    <label>{row.net_disc}%</label>
                                  )}
                                {includes(userInfo.role_name, "MHC Dealer") &&
                                  !includes(
                                    userInfo.role_name,
                                    "Payment Verificator"
                                  ) &&
                                  !row.edit_disc_allowed && (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: "10px",
                                      }}
                                    >
                                      <div> {setValueDisc(row.net_disc)}%</div>
                                      {!locked && (
                                        <i
                                          className="fa fa-edit"
                                          style={{
                                            color: "green",
                                            cursor: "pointer",
                                          }}
                                          onClick={(e) => {
                                            const det = [...detail];
                                            det[index].edit_disc_allowed = true;
                                            setInfo({
                                              ...info,
                                              detail: det,
                                            });
                                          }}
                                        ></i>
                                      )}
                                    </div>
                                  )}
                                {includes(userInfo.role_name, "MHC Dealer") &&
                                  row.edit_disc_allowed && (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: "10px",
                                      }}
                                    >
                                      <input
                                        onChange={(e) =>
                                          onChangeDiscount(e, index)
                                        }
                                        min={0}
                                        max={100}
                                        disabled={!row.edit_disc_allowed}
                                        placeholder={(
                                          net_discs[index] || 0
                                        ).toString()}
                                        style={{ width: "80px" }}
                                      />
                                      <i
                                        className="fa fa-check"
                                        style={{
                                          color: "green",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) =>
                                          onSubmitDiscount(
                                            net_discs[index],
                                            index,
                                            row
                                          )
                                        }
                                      ></i>
                                    </div>
                                  )}
                              </td>
                              <td width={180}>
                                <select
                                  name="ppn"
                                  className="form-control ps-0"
                                  style={{ width: 100 }}
                                  onChange={(e) => onChangePPN(e, row)}
                                  value={row.ppn}
                                  disabled={
                                    row.type == "R" && state.docnum !== "-"
                                    // row.free == 1 ||
                                    // locked ||
                                    // info.status_so === "Cancelled"
                                  }
                                >
                                  {listppn.map((_ppn, i) => (
                                    <option
                                      key={`ppn-` + i}
                                      value={parseFloat(_ppn.Rate)}
                                    >
                                      {NumberFormat(_ppn.Rate)}%
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td width={150}>
                                <select
                                  name="pph"
                                  className="form-control ps-0"
                                  style={{ width: 80 }}
                                  onChange={(e) => onChangePPH(e, row)}
                                  value={row.pph}
                                  disabled={
                                    row.free == 1 ||
                                    locked ||
                                    info.status_so === "Cancelled" ||
                                    includes(userInfo.role_name, "MHC Dealer")
                                  }
                                >
                                  <option value="y">Yes</option>
                                  <option value="n">No</option>
                                </select>
                              </td>
                              <td
                                style={{ paddingRight: 0, textAlign: "right" }}
                              >
                                {NumberFormat(row.net_disc_amt)}
                              </td>
                              <td width={140}>
                                <select
                                  name="order_type"
                                  className="form-control ps-0"
                                  style={{ width: 140 }}
                                  onChange={(e) => onChangeOrderType(e, row)}
                                  value={row.M_TP_PENJ}
                                  disabled={orderTypeSelectDisabled(row)}
                                >
                                  {info.ordertype
                                    .filter((rows) => {
                                      if (
                                        row.type === "R" ||
                                        row.type === "D"
                                      ) {
                                        return rows.value == "FGS";
                                      } else {
                                        if (
                                          row.paketid?.substring(0, 4) ===
                                          "PREO"
                                        ) {
                                          if (
                                            [
                                              "FGS",
                                              "TRD",
                                              "PMR",
                                              "PMT",
                                            ].includes(rows.value)
                                          )
                                            return rows.value;
                                        } else return rows.value;
                                      }
                                    })
                                    .map((_type, i) => (
                                      <option
                                        key={`type-` + i}
                                        value={_type.value}
                                      >
                                        {_type.label}
                                      </option>
                                    ))}
                                </select>
                              </td>
                              <td>
                                {row.free == 0 &&
                                  locked == false &&
                                  (row.paketid == null || row.paketid == "") &&
                                  info.status_so !== "Cancelled" && (
                                    <div>
                                      <button
                                        onClick={() => promo(row)}
                                        className="btn btn-outline-warning"
                                        style={{ border: "dotted", width: 100 }}
                                        type="button"
                                        disabled={includes(
                                          userInfo.role_name,
                                          "MHC Dealer"
                                        )}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-tags-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                                          <path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z" />
                                        </svg>
                                        &nbsp;Promo
                                      </button>
                                    </div>
                                  )}
                                {row.free == 0 &&
                                  locked == false &&
                                  row.paketid !== null &&
                                  row.paketid !== "" &&
                                  row.paketid.substring(0, 4) !== "PREO" &&
                                  info.status_so !== "Cancelled" && (
                                    <div>
                                      <button
                                        onClick={() => cancelpromo(row)}
                                        className="btn btn-outline-danger"
                                        style={{ border: "dotted", width: 100 }}
                                        type="button"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-tags-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                                          <path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z" />
                                        </svg>
                                        &nbsp;Cancel
                                      </button>
                                    </div>
                                  )}
                                {row.paketid !== null &&
                                  row.paketid !== "" &&
                                  row.paketid.substring(0, 4) === "PREO" && (
                                    <div>PREORDER</div>
                                  )}
                              </td>
                              <td>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultChecked={row.delivery}
                                    onChange={(e) => onChangeDelivery(e, row)}
                                    disabled={
                                      locked ||
                                      row.type == "I" ||
                                      info.status_so === "Cancelled"
                                    }
                                  />
                                </div>
                              </td>
                              {/*<td>
                                                            {!row.additional_address && <div>
                                                                <button className="btn btn-outline-warning" style={{ border: 'dotted', width: 100 }} onClick={() => modalAdditionalRef.current[row.id].openThisModal()} disabled={(locked || info.status_so == "Cancelled")}>
                                                                    + Add
                                                                </button>
                                                                <CustomerForm key={row.id} id={row.id} ref={(el) => setRef(el, row.id)}  saveFunction={onAddAdditionalAddress}/>
                                                            </div>}
                                                            {row.additional_address && row.additional_address !="" && 
                                                                <div style={{display:"flex"}}>
                                                                     <div style={{display:"flex", flexDirection:"column"}}>
                                                                        <div style={{fontWeight:"700"}}>{row.additional_receiver}</div> 
                                                                            <div style={{wordWrap:"break-word"}}>
                                                                                {row.additional_address}, 
                                                                                {row.additional_city},&nbsp;{row.additional_county}
                                                                            </div>
                                                                            <div>
                                                                                {row.additional_phone}
                                                                            </div>
                                                                    </div>
                                                                    {(!locked && info.status_so !== "Cancelled") && <div style={{color:"red", fontWeight:"700", cursor:"pointer"}} onClick={(e) => onDeleteAdditionalAddress(e, row)}>X</div>}
                                                                </div>
                                                            }
                                                        </td>*/}
                            </tr>
                            {row.paketid && (
                              <>
                                <tr key={`tr-` + index}>
                                  <td colSpan={7}></td>
                                  <td
                                    colSpan={3}
                                    style={{ fontSize: 14, padding: 0 }}
                                  >
                                    {row.paketid.substring(0, 4) === "PREO"
                                      ? "PREORDER : "
                                      : ""}{" "}
                                    {row.paket_name}
                                  </td>
                                  <td
                                    style={{ padding: 0, textAlign: "right" }}
                                  >
                                    {NumberFormat(Math.round(row.disc_2))}
                                  </td>
                                  <td colSpan={2}></td>
                                </tr>
                                <tr>
                                  <td colSpan={7}></td>
                                  <td
                                    colSpan={3}
                                    style={{
                                      fontSize: 14,
                                      padding: 0,
                                      fontWeight: 500,
                                    }}
                                  >
                                    Final Price
                                  </td>
                                  <td
                                    style={{ padding: 0, textAlign: "right" }}
                                  >
                                    {NumberFormat(Math.round(row.final_price))}
                                  </td>
                                  <td colSpan={2}></td>
                                </tr>
                              </>
                            )}
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div>
                    {order_no.substring(0, 3) !== "TMP" &&
                      userInfo.role_name !== "SO Payment Verificator" &&
                      userInfo.role_name !==
                      "SO Payment Verificator - MHC Dealer" && (
                        <div>
                          <h5>Purchase Order</h5>
                          <div style={{ padding: "0.5em 2em" }}>
                            <ol>
                              {!po_list.length &&
                                "Tidak Ada Purchase Order untuk SO ini"}
                              {po_list.length > 0 &&
                                po_list.map((po, index) => (
                                  <li
                                    key={index}
                                    style={{ margin: "0.5em auto" }}
                                  >
                                    {orderTypeTranslator(po.m_tp_penj)} (
                                    <Link
                                      to={`/purchaseorder/edit/${po.docnumpo}`}
                                    >
                                      {po.docnumpo}
                                    </Link>
                                    ){" "}
                                  </li>
                                ))}
                            </ol>
                          </div>
                        </div>
                      )}

                    {order_no.substring(0, 3) !== "TMP" &&
                      (userInfo.role_name == "SO Payment Verificator" ||
                        userInfo.role_name ==
                        "SO Payment Verificator - MHC Dealer") && (
                        <div>
                          <h5>Purchase Order</h5>
                          <div style={{ padding: "0.5em 2em" }}>
                            <ol>
                              {!po_list.length &&
                                "Tidak Ada Purchase Order untuk SO ini"}
                              {po_list.length > 0 &&
                                po_list.map((po, index) => (
                                  <li
                                    key={index}
                                    style={{ margin: "0.5em auto" }}
                                  >
                                    {orderTypeTranslator(po.m_tp_penj)} (
                                    <Link
                                      to={`/estatement/purchaseorder/${po.docnumpo}`}
                                    >
                                      {po.docnumpo}
                                    </Link>
                                    ){" "}
                                  </li>
                                ))}
                            </ol>
                          </div>
                        </div>
                      )}
                  </div>
                  {locked == false && info.status_so != "Cancelled" && (
                    <div
                      className="row d-flex align-items-center justify-content-center"
                      style={{ marginBottom: 30 }}
                    >
                      <button
                        onClick={addProduct}
                        className="btn btn-outline-primary"
                        style={{ border: "none", width: 200 }}
                        type="button"
                      >
                        <span className="fas fa-plus"></span> Add Product
                      </button>
                    </div>
                  )}
                  <div className="row" style={{ marginBottom: 50 }}>
                    <div className="col-sm-7">
                      {!includes(userInfo.role_name, "Payment Verificator") && (
                        <div className="note">
                          Dokumen ini bukan merupakan bukti transaksi, silakan
                          melakukan pembayaran terlebih dahulu. Pembayaran yang
                          dilakukan melalui sistem kami akan dianggap sah
                          apabila memenuhi syarat-syarat berikut:
                          <ul>
                            <li style={{ marginTop: "10px" }}>
                              <b>Kartu Kredit atau Kartu Debit:</b>
                            </li>
                            Transaksi menggunakan Kartu Kredit atau Kartu Debit
                            dianggap sah jika mengunakan mesin EDC yang tersedia
                            pada MHC Store.
                            <li style={{ marginTop: "10px" }}>
                              <b>Payment Transfer Bank: </b>
                            </li>
                            Pembayaran menggunakan Payment Gateway(Xendit). yang
                            akan mengirimkan link payment melalu WA/Email yang
                            bisa anda transfer dan akan di verifikasi oleh
                            payment gateway. Customer akan menerima email berupa
                            INOVICE sebagai bukti transaksi setelah pembayaran
                            terverifikasi oleh system
                          </ul>
                        </div>
                      )}
                      <div className="note">
                        <h6>Sales Remark:</h6>
                        <textarea
                          style={{ width: "100%", height: "200px" }}
                          value={info.sales_remark}
                          onChange={(e) =>
                            setInfo({ ...info, sales_remark: e.target.value })
                          }
                          disabled={state.order_no.substring(0, 3) !== "TMP"}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-sm-5">
                      {info.status_so !== "Cancelled" &&
                        !includes(userInfo.role_name, "Payment Verificator") &&
                        !includes(userInfo.role_name, "MHC Dealer") && (
                          <h2 className="title-promo">PROMO CODE</h2>
                        )}
                      {!state.kupon_kode &&
                        info.status_so !== "Cancelled" &&
                        !includes(userInfo.role_name, "MHC Dealer") &&
                        !includes(
                          userInfo.role_name,
                          "Payment Verificator"
                        ) && (
                          <div
                            className="d-flex align-items-center justify-content-center promo"
                            onClick={applyPromo}
                          >
                            APPLY PROMO / CAMPAIGN
                          </div>
                        )}
                      {state.kupon_kode &&
                        info.status_so !== "Cancelled" &&
                        !includes(
                          userInfo.role_name,
                          "Payment Verificator"
                        ) && (
                          <div
                            className="d-flex justify-content-center"
                            style={{
                              fontWeight: 900,
                              color: "#333",
                              marginBottom: 17,
                              padding: 5,
                              border: 1,
                              borderColor: "#CCC",
                              borderStyle: "solid",
                              backgroundColor: "#EEE",
                            }}
                          >
                            {state.kupon_kode}
                            <span
                              style={{
                                marginLeft: 7,
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={() => cancelpromokode()}
                            >
                              <img src={trash} />
                            </span>
                          </div>
                        )}
                      {info.status_so !== "Cancelled" &&
                        !includes(userInfo.role_name, "Payment Verificator") &&
                        !includes(userInfo.role_name, "MHC Dealer") && (
                          <div className="row">
                            <div className="col-sm-6">
                              <button
                                className="btn btn-primary btn-block"
                                style={{
                                  backgroundColor: "#BE4A31",
                                  marginBottom: 30,
                                }}
                                type="button"
                                onClick={showDeduction}
                                disabled={
                                  locked ||
                                  includes(userInfo.role_name, "MHC Dealer")
                                }
                              >
                                Additional Deduction
                              </button>
                            </div>
                            <div className="col-sm-6">
                              <button
                                className="btn btn-outline-danger btn-block"
                                style={{ marginBottom: 30 }}
                                type="button"
                                onClick={showPPH}
                                disabled={
                                  locked ||
                                  includes(userInfo.role_name, "MHC Dealer")
                                }
                              >
                                PPH
                              </button>
                            </div>
                          </div>
                        )}

                      <h2 className="title-promo">Detail Price</h2>
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          Total Before Discount
                        </div>
                        <div className="col-sm-6 text-right">
                          {NumberFormat(info.total_before_discount_with_free)}
                        </div>
                        <div
                          className="col-sm-6 mb-2"
                          style={{ color: "#BE4A31" }}
                        >
                          Campaign/Net Discount
                        </div>
                        <div
                          className="col-sm-6 text-right"
                          style={{ color: "#BE4A31" }}
                        >
                          -{" "}
                          {NumberFormat(
                            info.total_before_discount_with_free -
                            Math.round(total) -
                            deduction
                          )}
                        </div>
                        {deduction > 0 && (
                          <>
                            <div
                              className="col-sm-6 mb-2"
                              style={{ color: "#BE4A31" }}
                            >
                              Additional Discount
                            </div>
                            <div
                              className="col-sm-6 text-right"
                              style={{ color: "#BE4A31" }}
                            >
                              -{" "}
                              {NumberFormat(
                                Math.round(ParseDecimal(deduction))
                              )}
                            </div>
                          </>
                        )}
                        <div className="col-sm-6 mb-2">
                          <b>Total</b>
                        </div>
                        <div className="col-sm-6 text-right">
                          <b>{NumberFormat(Math.round(total))}</b>
                        </div>
                        <div className="col-sm-6 mb-2">Total Before Tax</div>
                        {/*<div className='col-sm-6 text-right'>{NumberFormat(Math.round(ParseDecimal(info.total_dpp-deduction)))}</div>*/}
                        <div className="col-sm-6 text-right">
                          {NumberFormat(Math.round(total - total_before_tax))}
                        </div>
                        <div className="col-sm-6 mb-2">Tax</div>
                        <div className="col-sm-6 text-right">
                          {NumberFormat(total_before_tax)}
                        </div>
                        {/* <div className='col-sm-6 mb-2'>NON PPN</div>
                                                <div className='col-sm-6 text-right'>{NumberFormat(Math.round( ParseDecimal(Math.abs(info.grand_total - info.total_dpp - info.total_ppn + info.total_pph))))}</div>*/}
                        <div className="col-sm-6 mb-2">
                          Witholding Tax{" "}
                          {info.pph_rate > 0 && "(" + info.pph_rate + "%)"}
                        </div>
                        <div className="col-sm-6 text-right">
                          (
                          {NumberFormat(
                            Math.round(ParseDecimal(info.total_pph))
                          )}
                          )
                        </div>

                        <div className="col-sm-6 grand-total">Grand Total</div>
                        <div className="col-sm-6 text-right grand-total">
                          {NumberFormat(Math.round(total))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-sm-12"
                    style={{ padding: "0 2rem 1.5rem 2rem" }}
                  >
                    {!state.note_approval && state.approved_date && (
                      <div style={{ padding: 10, background: "#ffeecf" }}>
                        <div
                          style={{
                            marginBottom: 0,
                            marginTop: 5,
                            fontWeight: "bold",
                            fontSize: 18,
                          }}
                        >
                          Informasi Approval :{" "}
                        </div>
                        <h4
                          style={{
                            fontStyle: "italic",
                            fontSize: 21,
                            color: "rgb(255, 168, 0)",
                            fontWeight: 500,
                          }}
                        >
                          - Sudah di approve pada tanggal{" "}
                          {moment(state.approved_date).format(
                            "DD MMM YYYY HH:mm:ss"
                          )}
                        </h4>
                      </div>
                    )}
                    {info.status_so == "Reject" && (
                      <div style={{ padding: 10, background: "#f71a1a21" }}>
                        <div
                          style={{
                            marginBottom: 0,
                            marginTop: 5,
                            fontWeight: "bold",
                            fontSize: 18,
                          }}
                        >
                          Informasi Reject :{" "}
                        </div>
                        <h4
                          style={{
                            fontStyle: "italic",
                            fontSize: 21,
                            color: "red",
                            fontWeight: 500,
                          }}
                        >
                          - Sudah di reject pada tanggal{" "}
                          {moment(state.approved_date).format(
                            "DD MMM YYYY HH:mm:ss"
                          )}
                          <br />- Catatan : {state.note_approval}
                        </h4>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {locked && info.status_so == "Cancelled" && (
                <div className="row" style={{ justifyContent: "flex-end" }}>
                  <div className="col-sm-2">
                    <Link
                      to="/"
                      className="btn btn-readonly btn-block"
                      style={{ marginBottom: 30 }}
                    >
                      Back
                    </Link>
                  </div>
                </div>
              )}
              {locked &&
                (info.status_so == "Open" ||
                  info.status_so == "Closed" ||
                  info.status_so == "Pending") &&
                state.docnum == "-" && (
                  <div className="row" style={{ justifyContent: "flex-end" }}>
                    <div className="col-sm-2">
                      <button
                        className="btn btn-danger btn-block"
                        style={{ marginBottom: 30 }}
                        type="button"
                        onClick={rehitSAP}
                      >
                        RESUBMIT SAP
                      </button>
                    </div>
                  </div>
                )}
              {locked == false &&
                info.status_so != "NotSync" &&
                info.status_so != "Sync" &&
                info.status_so != "Cancelled" && (
                  <div className="row" style={{ justifyContent: "flex-end" }}>
                    <div className="col-sm-2">
                      <Link
                        to="/"
                        className="btn btn-readonly btn-block"
                        style={{ marginBottom: 30 }}
                      >
                        Cancel
                      </Link>
                    </div>
                    <div className="col-sm-2">
                      <button
                        className="btn btn-modena btn-block"
                        style={{ marginBottom: 30 }}
                        type="button"
                        onClick={submitSO}
                      >
                        Save Order
                      </button>
                    </div>
                  </div>
                )}

              {state.payment_show && (
                <>
                  <div className="card shadow mb-4">
                    <div className="card-header py-3 bg-white">
                      <div className="row">
                        <div className="col-sm-10">
                          <h6 className="m-0 title-breadcrum tx-gray">
                            Payment
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <Overlay display={state.processing} />
                      {listPayment.map((row, index) => (
                        <div
                          className="border border-lg rounded mb-4"
                          style={
                            row.isSave ? { backgroundColor: "#f4f4f494" } : {}
                          }
                        >
                          <div className="row" style={{ padding: "10px 65px" }}>
                            <div className="col-sm-6">
                              <div className="mb-3">
                                <MSelect
                                  label="Payment Type"
                                  options={options_payment}
                                  disabled={
                                    (info.status_so == "Closed" &&
                                      info.payment_verified !== false) ||
                                    userInfo.role_name ==
                                    "SO Payment Verificator" ||
                                    userInfo.role_name ==
                                    "SO Payment Verificator - MHC Dealer"
                                  }
                                  value={row.payment_type}
                                  onChange={(e) =>
                                    onChangePaymentType(e, row.index)
                                  }
                                />
                              </div>
                              {row.invoice_url && (
                                <div className="mb-3">
                                  <label>Payment Link</label>
                                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <a
                                      href={row.invoice_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ wordBreak: "break-all" }}
                                    >
                                      {row.invoice_url}
                                    </a>
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm"
                                      style={{ padding: "2px 8px" }}
                                      onClick={() => {
                                        navigator.clipboard.writeText(row.invoice_url);
                                      }}
                                    >
                                      Copy
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-sm-6">
                              <div className="mb-3">
                                <label>Nominal</label>
                                <div className="input-group input-group-joined">
                                  <CurrencyInput
                                    className="form-control ps-0"
                                    name="nominal_payment"
                                    type="text"
                                    decimalSeparator=","
                                    groupSeparator="."
                                    defaultValue={row.nominal_payment}
                                    decimalsLimit={2}
                                    style={{ textAlign: "right" }}
                                    placeholder="0"
                                    disabled={
                                      (info.status_so == "Closed" &&
                                        info.payment_verified !== false) ||
                                      userInfo.role_name ==
                                      "SO Payment Verificator" ||
                                      userInfo.role_name ==
                                      "SO Payment Verificator - MHC Dealer"
                                    }
                                    onChange={(e) =>
                                      onChangeNominal(e, row.index)
                                    }
                                    readOnly={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {showBankCardnumber && (
                            <div
                              className="row"
                              style={
                                info.status_so !== "Closed"
                                  ? { padding: "10px 65px" }
                                  : { padding: "0px 65px" }
                              }
                            >
                              <div className="col-sm-6">
                                <div className="mb-3">
                                  {(info.status_so !== "Closed" ||
                                    info.payment_verified === false) && (
                                      <MSelect
                                        label="Bank"
                                        options={bank}
                                        disabled={
                                          (info.status_so == "Closed" &&
                                            info.payment_verified !== false) ||
                                          userInfo.role_name ==
                                          "SO Payment Verificator" ||
                                          userInfo.role_name ==
                                          "SO Payment Verificator - MHC Dealer"
                                        }
                                        value={row.bank}
                                        onChange={(e) =>
                                          onChangeBank(e, row.index)
                                        }
                                      />
                                    )}
                                  {info.status_so == "Closed" &&
                                    info.payment_verified !== false && (
                                      <MSelect
                                        label="Bank"
                                        options={bank}
                                        disabled={true}
                                        value={row.bank}
                                        onChange={(e) =>
                                          onChangeBank(e, row.index)
                                        }
                                      />
                                    )}
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="mb-3">
                                  <label>Card Number</label>
                                  <div className="input-group input-group-joined">
                                    <input
                                      className="form-control ps-0"
                                      name="card_number"
                                      type="text"
                                      defaultValue={row.card_number}
                                      style={{ textAlign: "left" }}
                                      disabled={
                                        (info.status_so == "Closed" &&
                                          info.payment_verified !== false) ||
                                        userInfo.role_name ==
                                        "SO Payment Verificator" ||
                                        userInfo.role_name ==
                                        "SO Payment Verificator - MHC Dealer"
                                      }
                                      onChange={(e) =>
                                        onChangeCardNumber(e, row.index)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                      {listPayment.length > 0 && showBankCardnumber && (
                        <div className="row" style={{ padding: "10px 65px" }}>
                          <div className="col-sm-6">
                            <div className="mb-3">
                              <h3>Upload Proof for All Payments</h3>
                              <div style={{ marginTop: "35px" }}>
                                <button
                                  disabled={
                                    (info.status_so == "Closed" &&
                                      info.payment_verified !== false) ||
                                    userInfo.role_name ==
                                    "SO Payment Verificator" ||
                                    userInfo.role_name ==
                                    "SO Payment Verificator - MHC Dealer"
                                  }
                                  className="btn btn-modena"
                                  type="button"
                                  onClick={() => onSelectImage()}
                                >
                                  Choose File
                                </button>
                                <input
                                  id="payment-upload"
                                  type="file"
                                  accept="image/png, image/jpg, image/jpeg"
                                  className="d-none"
                                  onChange={(e) => onImageChange(e)}
                                  required
                                />
                              </div>
                              <p>
                                * Supported formats : JPEG & PNG
                                <b>
                                  <i>(Max file size is 1 MB)</i>
                                </b>
                              </p>
                            </div>
                            {listPayment.img_upload && (
                              <div className="mb-4">
                                <a href={listPayment.img_upload} target="child">
                                  <img
                                    src={listPayment.img_upload}
                                    className="img-responsive"
                                    style={{ width: 160, height: 160 }}
                                  />
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {listPayment.length > 0 &&
                        info.status_so == "Closed" &&
                        showBankCardnumber &&
                        info.payment_verified &&
                        ((po_list.length > 0 &&
                          po_list[0].status == "COMPLETED") ||
                          po_list.length == 0) && (
                          <div className="col-sm-4">
                            <Button
                              loading={state.processingBtn}
                              label="Send Notif Email Customer"
                              severity="secondary"
                              className="btn btn-primary btn-block"
                              style={{
                                marginBottom: 30,
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: 10,
                                fontWeight: 600,
                              }}
                              onClick={() => {
                                onSendEmailNotifCustomerNonIPG();
                              }}
                              text
                              rounded
                              outlined
                            ></Button>
                          </div>
                        )}
                    </div>

                    <div
                      className="row"
                      style={{
                        marginBottom: 30,
                        marginTop: 30,
                        alignSelf: "end",
                        marginRight: 60,
                      }}
                    >
                      <div>
                        <b>Grand Total</b>{" "}
                        {NumberFormat(ParseDecimal(state.total_payment))}
                      </div>
                    </div>
                    {
                      (info.status_so !== "Closed" &&
                        info.status_so !== "Cancelled") ||
                      (info.status_so === "Closed" &&
                        info.payment_verified === false &&
                        userInfo.role_name !== "SO Payment Verificator" &&
                        userInfo.role_name !==
                        "SO Payment Verificator - MHC Dealer") /*&&
                                    <div className='row d-flex align-items-center justify-content-center' style={{ marginBottom: 30 }}>
                                        <button onClick={addPayment} className="btn btn-outline-primary" style={{ border: 'none', width: 200 }} type="button">
                                            <span className='fas fa-plus'></span> Add Payment
                                        </button>
                                    </div>*/
                    }
                  </div>
                  {info.status_so == "Closed" &&
                    (userInfo.role_name == "SO Payment Verificator" ||
                      userInfo.role_name ==
                      "SO Payment Verificator - MHC Dealer") &&
                    info.payment_verification_date && (
                      <div className="row" style={{ margin: "20px auto" }}>
                        <div
                          className="col-md-12"
                          style={
                            !info.payment_verified
                              ? {
                                backgroundColor: "#DC3545",
                                padding: "1rem 1rem",
                              }
                              : {
                                backgroundColor: "#5cb85c",
                                padding: "1rem 1rem",
                              }
                          }
                        >
                          <h4 style={{ color: "white" }}>
                            {" "}
                            Payment{" "}
                            {info.payment_verified
                              ? "Verified"
                              : "Rejected"} at{" "}
                            {moment(info.payment_verification_date).format(
                              "DD-MM-YYYY HH:mm:ss"
                            )}{" "}
                            by {info.payment_verified_by}
                          </h4>
                        </div>
                      </div>
                    )}
                  <div className="row" style={{ justifyContent: "flex-end" }}>
                    <div className="col-sm-2">
                      <Link
                        to="/salesorder"
                        className="btn btn-readonly btn-block"
                        style={{ marginBottom: 30 }}
                      >
                        Back
                      </Link>
                    </div>
                    {info.status_so === "Closed" &&
                      state.listPayment[0]?.payment_type === "IPG" &&
                      !info.payment_verification_date &&
                      userInfo.role_name !== "SO Payment Verificator" &&
                      userInfo.role_name !==
                      "SO Payment Verificator - MHC Dealer" && (
                        <div className="col-sm-2">
                          <button
                            className="btn btn-danger btn-block"
                            style={{ marginBottom: 30 }}
                            type="button"
                            onClick={() => {
                              onCancelPaymentLink();
                            }}
                          >
                            Cancel Payment Link
                          </button>
                        </div>
                      )}
                    {((info.status_so !== "Closed" &&
                      info.status_so !== "Cancelled") ||
                      (info.status_so === "Closed" &&
                        info.payment_verified === false &&
                        userInfo.role_name !== "SO Payment Verificator" &&
                        userInfo.role_name !==
                        "SO Payment Verificator - MHC Dealer")) &&
                      !hide_submit_payment && (
                        <div className="col-sm-2">
                          <button
                            className="btn btn-modena btn-block"
                            style={{ marginBottom: 30 }}
                            type="button"
                            onClick={onSavePayment}
                            disabled={listPayment.length <= 0 || state.loading}
                          >
                            Submit Payment
                          </button>
                        </div>
                      )}

                    {info.status_so == "Closed" &&
                      (userInfo.role_name == "SO Payment Verificator" ||
                        userInfo.role_name ==
                        "SO Payment Verificator - MHC Dealer") &&
                      !info.payment_verification_date &&
                      listPayment[0].payment_type !== "IPG" && (
                        <>
                          <div className="col-sm-2">
                            <button
                              className="btn btn-danger btn-block"
                              style={{ marginBottom: 30 }}
                              type="button"
                              onClick={() => onVerifyPayment("N")}
                            >
                              Reject Payment
                            </button>
                          </div>
                          <div className="col-sm-2">
                            <button
                              className="btn btn-success btn-block"
                              style={{ marginBottom: 30 }}
                              type="button"
                              onClick={() => onVerifyPayment("R")}
                            >
                              Verify Payment
                            </button>
                          </div>
                        </>
                      )}
                    {info.status_so == "Closed" &&
                      (userInfo.role_name == "SO Payment Verificator" ||
                        userInfo.role_name ==
                        "SO Payment Verificator - MHC Dealer") &&
                      !info.payment_verification_date &&
                      listPayment[0].payment_type === "IPG" && (
                        <div className="col-sm-2">
                          <button
                            className="btn btn-danger btn-block"
                            style={{ marginBottom: 30 }}
                            type="button"
                            onClick={() => onCancelPaymentLink()}
                          >
                            Cancel Payment Link
                          </button>
                        </div>
                      )}
                  </div>
                </>
              )}

              {/*orderNumber.substring(0, 4) == "MoRe" && (
                <div style={{ float: "right" }}>
                  <div>
                    <button
                      className="btn btn-modena btn-block"
                      style={{ marginBottom: 30, width: "30%" }}
                      type="button"
                      onClick={() => {
                        rehitInvoice(state.order_id).then((res) => {
                          if (res.data.status == 201) {
                            Swal.fire({
                              icon: "success",
                              title: "Success",
                              text: res.data.message,
                            }).then((_) => {
                              navigate(0);
                            });
                          } else {
                            Swal.fire({
                              icon: "error",
                              title: "Failed",
                              text: "Invoice creation failed",
                            }).then((_) => {
                              navigate(0);
                            });
                          }
                        });
                      }}
                      disabled={!rehitButtonsState.invoice_rehit}
                    >
                      Invoice Rehit
                    </button>
                    <button
                      className="btn btn-modena btn-block"
                      style={{ marginBottom: 30, width: "30%" }}
                      type="button"
                      onClick={() => {
                        rehitDP(state.order_id).then((res) => {
                          if (res.data.status == 201) {
                            Swal.fire({
                              icon: "success",
                              title: "Success",
                              text: res.data.message,
                            });
                          } else {
                            Swal.fire({
                              icon: "error",
                              title: "Failed",
                              text: "DP creation failed",
                            });
                          }
                        });
                      }}
                      disabled={!rehitButtonsState.dp_rehit}
                    >
                      DP Rehit
                    </button>
                  </div>
                </div>
              )*/}
            </>
          )}
          {info.detail.length <= 0 && (
            <div className="row d-block">
              <div className="card shadow mb-4">
                <div className="card-body">
                  <div className="row d-flex align-items-center justify-content-center">
                    <img src={empty_data} />
                  </div>
                  {info.nama_customer != "" && (
                    <div className="row d-flex align-items-center justify-content-center mb-5">
                      <button
                        className="btn btn-dark"
                        type="button"
                        onClick={addProduct}
                      >
                        <span className="fas fa-plus"></span> Add Product
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div >
  );
};

export default SalesForm;
